<template>
	<div class="mode-index-root">
		<!-- 列表视图 -->
		<section class="dp-layout mode-index-page" v-show="!isEdit">
			<section class="dp-right">
				<div class="all_page_border mode-index-list-shell">
					<!--工具条-->
					<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
					<div class="dp-dept-hint">
						<span class="dp-dept-hint__label">当前学校</span>
						<span class="dp-dept-hint__value">{{ schoolDisplayName || '请在顶部选择学校' }}</span>
						<span class="dp-dept-hint__extra">共 {{ total }} 个模板</span>
					</div>
					<div class="mode-index-table-section">
						<div class="mode-index-table-scroll" ref="tableScrollWrap">
							<div class="tbl-scroll-host" v-loading="listLoading">
								<el-table height="100%" :data="list" ref="table" style="width: 100%" class="custom-tbl"
									header-row-class-name="table-header-custom" row-class-name="table-row-custom"
									@selection-change="handleSelectionChange">
									<el-table-column type="selection" width="55"> </el-table-column>

									<el-table-column prop="TemplateName" label="模板名称" width="" show-overflow-tooltip>
										<template slot-scope="scope">
											<span style="font-weight: 600; color: #303133;">{{ scope.row.TemplateName
											}}</span>
										</template>
									</el-table-column>

									<el-table-column prop="DepartmentName" label="所属机构" width="" show-overflow-tooltip>
										<template slot-scope="scope">
											<span>{{ formatDepartmentNameCol(null, null, scope.row.DepartmentName) ||
												'全局' }}</span>
										</template>
									</el-table-column>

									<el-table-column prop="IsPortrait" label="设备方向" width="" align="center">
										<template slot-scope="scope">
											<el-tag :type="scope.row.IsPortrait ? 'warning' : 'primary'" size="small"
												effect="light">
												<i
													:class="scope.row.IsPortrait ? 'el-icon-mobile-phone' : 'el-icon-monitor'"></i>
												{{ scope.row.IsPortrait ? '竖屏' : '横屏' }}
											</el-tag>
										</template>
									</el-table-column>

									<el-table-column prop="IsDefault" label="是否默认" width="" align="center">
										<template slot-scope="scope">
											<el-tag
												:type="(scope.row.IsDefault === true || scope.row.IsDefault === '1' || scope.row.IsDefault === 1) ? 'success' : 'info'"
												size="small" effect="dark">
												{{ (scope.row.IsDefault === true || scope.row.IsDefault === '1' ||
													scope.row.IsDefault === 1) ? '是' : '否' }}
											</el-tag>
										</template>
									</el-table-column>

									<el-table-column prop="BindKqTerminalIds" label="已应用设备" width="" align="center">
										<template slot-scope="scope">
											<el-button type="text" class="bind" style="font-weight: 500;"
												@click="onBindDeviceClick(scope.row)">
												<i class="el-icon-connection"></i>
												{{ scope.row.BindKqTerminalIds && scope.row.BindKqTerminalIds.length ?
													`${scope.row.BindKqTerminalIds.length}台设备` : '未应用' }}
											</el-button>
										</template>
									</el-table-column>

									<el-table-column label="操作" width="200" align="center">
										<template slot-scope="scope">
											<div class="table-op-pair">
												<el-button type="text" class="table-op-link" size="mini"
													@click="handleEditRow(scope.row)">编辑</el-button>
												<el-button type="text" class="table-op-link" size="mini"
													@click="handleCopy(scope.row)">复制</el-button>
												<el-button type="text" class="table-op-link table-op-link--danger"
													size="mini" @click="handleDelRow(scope.row)">删除</el-button>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
						<el-col :span="24" class="toolbar mode-index-list-pager">
							<el-pagination layout="total, prev, pager, next, jumper"
								@current-change="handleCurrentChange" :current-page="page" :page-size="PageSize"
								:total="total" style="float: right"></el-pagination>
						</el-col>
					</div>
				</div>
			</section>
		</section>

		<!-- 排版编辑模式 (IDE 三栏式布局) -->
		<div class="container edit" v-show="isEdit">
			<!-- 左侧组件库面板 -->
			<section class="left-panel">
				<div class="panel-header">
					<span class="panel-title"><i class="el-icon-menu"></i> 组件库</span>
				</div>
				<div class="grid-selects">
					<el-tabs v-model="activeName" type="card" class="component-tabs" style="width: 100%;">
						<el-tab-pane label="系统组件" name="defaultGrids"></el-tab-pane>
						<el-tab-pane label="自定义组件" name="customGrids"></el-tab-pane>
					</el-tabs>
					<div class="grid-list">
						<div @dragend="dragend" class="grid-select" draggable="true" unselectable="on"
							v-for="(item, index) in grids" :key="index" :data-index="index" :style="`width:${item.width}px;max-width:230px;height:${item.width < 230
								? item.height
								: item.height * (230 / item.width)
								}px;color:${item.color || '#000'};background:${item.background || '#fff'
								};`">
							<img v-if="item.icon" v-oss-src="getIconSrc(item)" :data-index="index" :alt="item.detail" />
							<div class="detail" v-else>{{ item.detail }}</div>
							<div class="remove" v-if="item.name === 'custom'" @click="removeCustom(index)">
								<el-icon name="delete"></el-icon>
							</div>
						</div>
						<div class="grid-select addBut" v-if="activeName === 'customGrids'">
							<div class="detail">
								<el-button class="but" type="primary" size="small" @click="addCustom = true">
									<el-icon name="plus"></el-icon>
									<span>添加自定义组件</span>
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- 中间画布预览面板 -->
			<!-- 右侧主面板 (原中间画布和右侧属性合并) -->
			<section class="preview-panel">
				<div class="preview-header">
					<!-- 模板全局操作与分辨率微调 -->
					<div class="global-actions-bar">
						<div class="action-item">
							<el-switch v-model="isOpenBottomNav" active-text="底部导航" size="small" @change="init" />
							<template v-if="isOpenBottomNav">
								<span class="res_separator" style="margin: 0 8px; color: #dcdfe6;">|</span>
								<span class="action-label">导航高度:</span>
								<el-input-number v-model="navHeight" :min="10" :max="500" :step="1" size="mini"
									controls-position="right" style="width: 90px;" placeholder="高度"
									@change="init"></el-input-number>
							</template>
						</div>
						<div class="action-item">
							<el-switch v-model="isPortrait" active-text="竖屏" inactive-text="横屏" size="small"
								@change="init" />
						</div>
						<div class="action-item">
							<span class="action-label">分辨率:</span>
							<el-input-number v-model="designWidth" :min="100" :max="10000" size="mini"
								controls-position="right" style="width: 100px;" placeholder="宽"
								@change="init"></el-input-number>
							<span style="margin: 0 4px; color: #909399;">x</span>
							<el-input-number v-model="designHeight" :min="100" :max="10000" size="mini"
								controls-position="right" style="width: 100px;" placeholder="高"
								@change="init"></el-input-number>
						</div>
						<div class="action-buttons">
							<el-button type="success" size="mini" icon="el-icon-check"
								@click="saveGrid(false)">保存首页</el-button>
							<el-button type="warning" size="mini" icon="el-icon-refresh-left"
								@click="resetGrid">恢复默认</el-button>
							<el-button type="danger" size="mini" icon="el-icon-delete"
								@click="clearGrid">清空布局</el-button>
							<el-button type="info" size="mini" icon="el-icon-close"
								@click="isEdit = false">取消</el-button>
						</div>
					</div>
				</div>
				<div class="bottom-content-area">
					<div class="preview-canvas-wrapper" ref="virtualBox">
						<!-- 设备物理外壳仿真 -->
						<div class="preview_device" :class="{ portrait: isPortrait }">
							<div class="device-screen">
								<div class="virtual" ref="virtual"
									:style="`width:${pageWidth}px;height:${pageHeight}px;`">
									<div class="virtualPageBox" ref="virtualPageBox" v-if="show"
										:style="`height:${isOpenBottomNav ? `calc(100% - ${getpagepxY(navDeviceHeight)}px)` : '100%'};`">
										<VueDraggableResizable ref="draggable" :x="getpagepxX(item.x)"
											:y="getpagepxY(item.y)" :w="getpagepxX(item.width)"
											:h="getpagepxY(item.height)" :minWidth="getpagepxX(item.minWidth)"
											:minHeight="getpagepxY(item.minHeight)"
											:lockAspectRatio="item.lockAspectRatio"
											@dragstop="(...e) => dragstop(...e, index)"
											@resizestop="(...e) => resizestop(...e, index)"
											@activated="activated(index)" @deactivated="deactivated"
											:prevent-deactivation="false" :parent="true"
											:draggable="index === selectIndex" v-for="(item, index) in layout"
											:key="index">
											<div class="grid">
												<img v-if="item.icon" v-oss-src="getIconSrc(item)" :data-index="index"
													:alt="item.detail" />
												<div class="detail"
													:style="`color:${item.color || '#000'};font-size:${getpagepxX(24)}px;background:${item.background || '#fff'};`"
													v-else>
													{{ item.detail }}
												</div>
												<div class="index"
													:style="`width:${getpagepxX(80)}px;left:${getpagepxX(10)}px;bottom:${getpagepxY(10)}px;font-size:${getpagepxX(20)}px`">
													组件{{ item.i }}
												</div>
											</div>
										</VueDraggableResizable>
									</div>
									<div class="menu" v-if="isOpenBottomNav"
										:style="`height:${getpagepxY(navDeviceHeight)}px;font-size:${getpagepxY(navDeviceHeight * 0.47)}px;`">
										<div>导</div>
										<div>航</div>
										<div>菜</div>
										<div>单</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- 右侧属性与操作面板 -->
					<section class="property-panel">
						<div class="panel-header">
							<span class="panel-title"><i class="el-icon-setting"></i> 组件属性</span>
						</div>
						<div class="property-content">
							<!-- 方向键可微调提示移动至此处 -->
							<div class="prop-group keyboard-tip-group">
								<div class="keyboard-tip-content">
									<i class="el-icon-info"></i> 选中组件后，键盘 <strong>方向键</strong> 可微调 1px，按住
									<strong>Shift+方向键</strong> 微调
									10px。
								</div>
							</div>

							<!-- 组件属性微调 -->
							<div class="prop-group" style="flex: 1; display: flex; flex-direction: column;">
								<div class="prop-group-title">选中组件属性</div>
								<div v-if="selectIndex !== -1"
									style="display: flex; flex-direction: column; gap: 12px;">
									<el-form label-position="left" label-width="80px" size="small">
										<el-form-item label="组件序号">
											<el-input-number v-model="layout[selectIndex].i" :min="1" :precision="0"
												style="width: 100%;" @change="handleIndexChange"></el-input-number>
										</el-form-item>
										<el-form-item label="组件名称">
											<strong>{{ layout[selectIndex].detail }}</strong>
										</el-form-item>
										<el-form-item label="坐标 X">
											<el-input-number v-model="layout[selectIndex].x" :min="0" :max="designWidth"
												style="width: 100%;"></el-input-number>
										</el-form-item>
										<el-form-item label="坐标 Y">
											<el-input-number v-model="layout[selectIndex].y" :min="0"
												:max="designHeight" style="width: 100%;"></el-input-number>
										</el-form-item>
										<el-form-item label="组件宽度">
											<el-input-number v-model="layout[selectIndex].width" :min="10"
												:max="designWidth" style="width: 100%;"></el-input-number>
										</el-form-item>
										<el-form-item label="组件高度">
											<el-input-number v-model="layout[selectIndex].height" :min="10"
												:max="designHeight" style="width: 100%;"></el-input-number>
										</el-form-item>
										<el-form-item label="锁定宽高比">
											<el-switch v-model="layout[selectIndex].lockAspectRatio"></el-switch>
										</el-form-item>

										<!-- 霸屏时间 -->
										<div v-if="layout[selectIndex].Times" class="times-config-box">
											<div class="times-config-title">组件霸屏时间设置</div>
											<div v-for="(timeItem, index) in layout[selectIndex].Times" :key="index"
												class="times-config-row">
												<el-date-picker :value="getLayoutTimePoint(timeItem, 0)" type="datetime"
													placeholder="开始时间" format="yyyy-MM-dd HH:mm:ss"
													value-format="yyyy-MM-dd HH:mm:ss" size="mini"
													style="width: 100%; margin-bottom: 5px;"
													@input="(val) => updateLayoutTimePoint(index, 0, val)"></el-date-picker>
												<el-date-picker :value="getLayoutTimePoint(timeItem, 1)" type="datetime"
													placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
													value-format="yyyy-MM-dd HH:mm:ss" size="mini"
													style="width: 100%; margin-bottom: 8px;"
													@input="(val) => updateLayoutTimePoint(index, 1, val)"></el-date-picker>
												<el-button size="mini" type="danger" plain style="width: 100%;"
													@click="removeAutoTime(index, 'layout')">删除此时段</el-button>
											</div>
											<el-button type="primary" size="mini" icon="el-icon-plus"
												style="width: 100%; margin-top: 10px;"
												@click="addAutoTime('layout')">添加霸屏时间</el-button>
										</div>
									</el-form>

									<el-button type="danger" icon="el-icon-delete" style="margin-top: 15px;"
										@click="deleteGrid">移除此组件</el-button>
								</div>
								<div v-else class="prop-empty-state">
									<i class="el-icon-mouse"></i>
									<p>请点击画布选中某个组件进行属性编辑</p>
								</div>
							</div>
						</div>
					</section>
				</div>
			</section>
		</div>

		<!-- 新增班牌/编辑模板弹窗 -->
		<el-dialog :title="homeData.Id ? '编辑模板' : '新增班牌'" :visible.sync="dialogVisible" width="65%" top="5vh"
			custom-class="custom-dialog">
			<el-form ref="addForm" :model="homeData" :rules="formRules" label-width="120px">
				<el-tabs v-model="dialogActiveTab" type="border-card" class="config-tabs">
					<!-- Tab 页签 1: 基本信息 -->
					<el-tab-pane label="基本信息" name="basic">
						<el-form-item label="模板名称" prop="TemplateName">
							<el-input v-model="homeData.TemplateName" placeholder="请输入模板名称"></el-input>
						</el-form-item>
						<el-form-item label="是否默认" prop="IsDefault">
							<el-radio-group v-model="homeData.IsDefault">
								<el-radio label="1">是</el-radio>
								<el-radio label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="设备方向">
							<el-radio-group v-model="homeData.IsPortrait" @change="handleDialogPortraitChange">
								<el-radio :label="false">横屏</el-radio>
								<el-radio :label="true">竖屏</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="画布分辨率">
							<div style="display: flex; align-items: center;">
								<el-input-number v-model="designWidth" :min="100" :max="10000" size="small"
									controls-position="right" style="width: 120px;" placeholder="宽"></el-input-number>
								<span style="margin: 0 8px; color: #909399;">x</span>
								<el-input-number v-model="designHeight" :min="100" :max="10000" size="small"
									controls-position="right" style="width: 120px;" placeholder="高"></el-input-number>
								<span style="margin-left: 12px; font-size: 12px; color: #909399;">
									(推荐默认：{{ homeData.IsPortrait ? '1080 x 1920 竖屏' : '1920 x 1080 横屏' }})
								</span>
							</div>
						</el-form-item>
						<!-- 自动开启人脸考勤时间段 -->
						<el-form-item label="自动考勤时间" prop="AutoTimes">
							<div v-for="(timeItem, index) in homeData.AutoTimes" :key="index" class="time-item-row">
								<span class="time-label">时段 {{ index + 1 }}:</span>
								<el-time-picker v-model="timeItem.startTime" format="HH:mm" placeholder="开始时间"
									value-format="HH:mm" @change="(val) => handleTimeChange(val, timeItem, 'startTime')"
									style="width: 140px; margin-right: 10px;"></el-time-picker>
								<span style="margin-right: 10px;">至</span>
								<el-time-picker v-model="timeItem.endTime" format="HH:mm" placeholder="结束时间"
									value-format="HH:mm" @change="(val) => handleTimeChange(val, timeItem, 'endTime')"
									:picker-options="{ selectableRange: `${timeItem.startTime || '00:00'}:00 - 23:59:59` }"
									style="width: 140px; margin-right: 15px;"></el-time-picker>
								<el-button size="small" type="danger" icon="el-icon-delete" circle
									@click="removeAutoTime(index)"></el-button>
							</div>
							<el-button type="primary" size="small" icon="el-icon-plus"
								@click="addAutoTime">添加时间段</el-button>
						</el-form-item>
						<!-- 应用设备 -->
						<el-form-item label="应用设备" prop="BindKqTerminalIds">
							<div class="terminal-transfer-shell mode-terminal-transfer">
								<el-transfer v-model="homeData.BindKqTerminalIds" :data="terminalTransferOptions"
									filterable :titles="['可选设备', '已选设备']" :props="{ key: 'key', label: 'label' }"
									:render-content="renderTerminalTransferItem"></el-transfer>
							</div>
						</el-form-item>
					</el-tab-pane>

					<!-- Tab 页签 2: 全局与考勤设置 -->
					<el-tab-pane label="全局与考勤设置" name="global">
						<div class="global-settings-tab">
							<div class="tab-section-block">
								<div class="tab-section-title"><i class="el-icon-s-promotion"></i> 页面展现与风格</div>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="页面风格">
											<el-radio-group v-model="pageMode" class="radio-group-wrap">
												<el-radio label="DefautModel">默认模式</el-radio>
												<el-radio label="StyleOne">风格一</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="主题模式">
											<el-radio-group v-model="themeMode" class="radio-group-wrap">
												<el-radio label="themeLight">浅色主题</el-radio>
												<el-radio label="themeDark">深色主题</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="首页作为屏保">
											<el-switch v-model="isHomeScreenSaver"></el-switch>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="进入屏保时间">
											<el-input-number v-model="screenSaverTime" :min="1" :max="60"
												style="width:150px"></el-input-number>
											<span class="form-unit">分钟</span>
										</el-form-item>
									</el-col>
								</el-row>
							</div>

							<div class="tab-section-block">
								<div class="tab-section-title"><i class="el-icon-user-solid"></i> 考勤与人脸基础配置</div>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="人脸考勤">
											<el-switch v-model="isOpenFaceAtten" active-text="开启"
												inactive-text="关闭"></el-switch>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="考勤显示照片">
											<el-switch v-model="isShowPhoto" active-text="显示"
												inactive-text="不显示"></el-switch>
										</el-form-item>
									</el-col>
								</el-row>

								<el-row :gutter="20">
									<el-col :span="24">
										<el-form-item label="考勤对象">
											<el-radio-group v-model="KqObject" class="radio-group-wrap">
												<el-radio label="">不统一设置</el-radio>
												<el-radio label="all">全部</el-radio>
												<el-radio label="student">学生</el-radio>
												<el-radio label="teacher">教职工</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="24">
										<el-form-item label="考勤模式">
											<el-radio-group v-model="attenMode" class="radio-group-wrap">
												<el-radio label="">不统一设置</el-radio>
												<el-radio label="default">普通考勤</el-radio>
												<el-radio label="course">课程考勤</el-radio>
												<el-radio label="gate">校门考勤</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label="自动退出考勤">
											<el-input-number v-model="attenAutoExitTime" :min="1" :max="60"
												style="width:150px"></el-input-number>
											<span class="form-unit">秒</span>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="考勤保持时间">
											<el-input-number v-model="attenKeepTime" :min="1" :max="60"
												style="width:150px"></el-input-number>
											<span class="form-unit">秒</span>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>
					</el-tab-pane>

					<!-- Tab 页签 3: 组件功能配置 -->
					<el-tab-pane label="组件功能配置" name="componentConfig">
						<!-- 倒计时组件配置 -->
						<div class="tab-section-title"><i class="el-icon-alarm-clock"></i> 倒计时组件配置</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="倒计时标题">
									<el-input v-model="customConfig.countdown.title"
										placeholder="请输入倒计时标题，如：高考倒计时"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="计时类型">
									<el-radio-group v-model="customConfig.countdown.type">
										<el-radio label="day">仅天数 (day)</el-radio>
										<el-radio label="minute">天/时/分 (minute)</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="目标截止时间">
									<el-date-picker v-model="customConfig.countdown.time" type="datetime"
										placeholder="请选择目标截止时间" :format="customConfig.countdown.type === 'day'
											? 'yyyy-MM-dd'
											: 'yyyy-MM-dd HH:mm'
											" :value-format="customConfig.countdown.type === 'day'
												? 'yyyy-MM-dd'
												: 'yyyy-MM-dd HH:mm'
												" style="width: 100%"></el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>

						<div class="tab-section-title" style="margin-top: 20px;"><i class="el-icon-menu"></i> 个人空间菜单配置
						</div>
						<!-- 个人空间配置 -->
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="开启个人空间">
									<el-switch v-model="isOpenPersonalSpace" active-text="开启"
										inactive-text="关闭"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="8">
								<el-form-item label="互动聊天">
									<el-switch v-model="customConfig.personalSpace.enableChat" active-text="开启"
										inactive-text="关闭"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="我的订餐">
									<el-switch v-model="customConfig.personalSpace.enableOrder" active-text="开启"
										inactive-text="关闭"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="我的德育分">
									<el-switch v-model="customConfig.personalSpace.enableMoral" active-text="开启"
										inactive-text="关闭"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 自定义菜单列表配置 -->
						<div class="custom-menu-section"
							style="margin-top: 15px; background: #fafafa; border: 1px solid #ebeef5; border-radius: 6px; padding: 15px;">
							<div
								style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
								<span
									style="font-size: 14px; font-weight: bold; color: #303133; display: flex; align-items: center; gap: 6px;">
									<i class="el-icon-circle-plus-outline" style="color: #409EFF;"></i> 自定义功能菜单
									<span
										style="font-size: 12px; font-weight: normal; color: #909399;">(可添加外链，点击时自动携带刷脸/刷卡人员数据)</span>
								</span>
								<el-button type="primary" size="mini" icon="el-icon-plus"
									@click="openAddCustomMenuDialog">
									添加自定义菜单
								</el-button>
							</div>

							<!-- 表格展示已配置的自定义菜单 -->
							<el-table :data="customConfig.personalSpace.customMenus || []" border size="small"
								style="width: 100%;" empty-text="暂无自定义菜单，可点击右上角「添加自定义菜单」进行配置">
								<el-table-column label="图标" width="70" align="center">
									<template slot-scope="scope">
										<div class="custom-menu-table-icon">
											<oss-el-image v-if="scope.row.icon" :src="getMenuIconPath(scope.row.icon)"
												style="width: 32px; height: 32px;" fit="contain">
												<div slot="error" class="image-slot"><i
														class="el-icon-picture-outline"></i></div>
											</oss-el-image>
											<i v-else class="el-icon-menu" style="font-size: 20px; color: #909399;"></i>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="title" label="菜单名称" width="140"></el-table-column>
								<el-table-column prop="target" label="链接地址" min-width="220"
									show-overflow-tooltip></el-table-column>
								<el-table-column label="拼接参数" min-width="180">
									<template slot-scope="scope">
										<template v-if="scope.row.params && scope.row.params.length">
											<el-tag v-for="paramKey in scope.row.params" :key="paramKey" size="mini"
												type="info" style="margin: 2px 4px 2px 0;">
												{{ getParamLabel(paramKey) }}
											</el-tag>
										</template>
										<span v-else style="color: #c0c4cc; font-size: 12px;">无拼接参数</span>
									</template>
								</el-table-column>
								<el-table-column label="状态" width="80" align="center">
									<template slot-scope="scope">
										<el-switch v-model="scope.row.show" size="mini" title="启用/禁用菜单"></el-switch>
									</template>
								</el-table-column>
								<el-table-column label="排序" width="90" align="center">
									<template slot-scope="scope">
										<el-button type="text" size="mini" icon="el-icon-top"
											:disabled="scope.$index === 0" @click="moveCustomMenuUp(scope.$index)"
											title="上移"></el-button>
										<el-button type="text" size="mini" icon="el-icon-bottom"
											:disabled="scope.$index === (customConfig.personalSpace.customMenus || []).length - 1"
											@click="moveCustomMenuDown(scope.$index)" title="下移"></el-button>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="120" align="center">
									<template slot-scope="scope">
										<el-button type="text" size="mini" icon="el-icon-edit"
											@click="openEditCustomMenuDialog(scope.row, scope.$index)">编辑</el-button>
										<el-button type="text" size="mini" icon="el-icon-delete"
											class="custom-menu-del-btn" style="color: #F56C6C !important;"
											@click="deleteCustomMenu(scope.$index)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>

						<!-- 首页德育模式 -->
						<div class="tab-section-title" style="margin-top: 20px;"><i class="el-icon-trophy"></i> 首页德育模式配置
						</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="展现模式">
									<el-radio-group v-model="customConfig.homeMoralMode.mode">
										<el-radio label="mascot">吉祥物模式 (mascot)</el-radio>
										<el-radio label="fiveStar">五星勋章模式 (fiveStar)</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 动态新增参数配置 -->
						<div class="tab-section-title"
							style="margin-top: 20px; display: flex; justify-content: space-between; align-items: center;">
							<div><i class="el-icon-magic-stick"></i> 扩展配置</div>
							<el-button type="text" size="small" icon="el-icon-edit-outline"
								@click="openDynamicSchemaDialog" v-if="isBlogAdmin">管理动态字段</el-button>
						</div>
						<div v-if="dynamicSchema && dynamicSchema.length > 0">
							<el-row :gutter="20">
								<el-col :span="12" v-for="(item, index) in dynamicSchema" :key="index">
									<el-form-item :label="item.label">
										<el-switch v-if="item.type === 'switch'"
											v-model="dynamicValues[item.key]"></el-switch>
										<el-input-number v-else-if="item.type === 'number'"
											v-model="dynamicValues[item.key]" style="width: 150px;"></el-input-number>
										<el-input v-else v-model="dynamicValues[item.key]"
											:placeholder="'请输入' + item.label"></el-input>
									</el-form-item>
								</el-col>
							</el-row>
						</div>
						<div v-else
							style="color: #909399; font-size: 13px; text-align: center; margin-top: 10px; padding-bottom: 10px;">
							暂无动态配置，可点击右上角管理添加</div>
					</el-tab-pane>

					<!-- Tab 页签 4: * 算法高级配置 -->
					<el-tab-pane label="* 算法高级配置" name="faceAlgorithm" v-if="isBlogAdmin">
						<div class="tab-section-title"><i class="el-icon-cpu"></i> 算法阈值高级设置</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="人脸识别算法">
									<el-radio-group v-model="faceAlgorithmType">
										<el-radio label="megvii">旷视 (megvii)</el-radio>
										<el-radio label="arcsoft">虹软 (arcsoft)</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="人脸比对阈值">
									<el-input-number v-model="faceSearchThreshold" :min="50" :max="100"
										style="width:150px"></el-input-number>
									<span class="form-helper">默认值: 72</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="人脸活体阈值">
									<el-input-number v-model="faceLivenessThreshold" :min="50" :max="100"
										style="width:150px"></el-input-number>
									<span class="form-helper">默认值: 70</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="高级活体阈值">
									<el-input-number v-model="faceLivenessGaThreshold" :min="50" :max="100"
										style="width:150px"></el-input-number>
									<span class="form-helper">默认值: 85</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="相似分差范围">
									<el-input-number v-model="faceSimilarityDelta" :min="1" :max="20"
										style="width:150px"></el-input-number>
									<span class="form-helper">默认值: 5</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="遮挡模式">
									<el-radio-group v-model="faceRcMode">
										<el-radio :label="1">常规模式</el-radio>
										<el-radio :label="2">防遮挡模式</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="启用活体检测">
									<el-switch v-model="faceLivenessEnabled"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>

					<!-- Tab 页签 4: * 高级 MQTT 设置 -->
					<el-tab-pane label="* 高级 MQTT 设置" name="mqtt" v-if="isBlogAdmin">
						<div class="tab-section-title"><i class="el-icon-connection"></i> 终端 MQTT 云端下发设置</div>
						<el-form-item label="服务器地址">
							<el-input v-model="mqttConfig.serverUri"
								placeholder="请输入 MQTT 地址，如 ws://ip:port/mqtt"></el-input>
						</el-form-item>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="MQTT 账号">
									<el-input v-model="mqttConfig.username" placeholder="请输入 MQTT 账号"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="MQTT 密码">
									<el-input v-model="mqttConfig.password" placeholder="请输入 MQTT 密码"
										autocomplete="off"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="心跳间隔">
									<el-input-number v-model="mqttConfig.heartbeatInterval" :min="1" :max="120"
										style="width:150px"></el-input-number>
									<span class="form-unit">分钟</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="H5 MQTT（H5班牌，仅支持WS协议）">
									<el-switch v-model="mqttConfig.h5MqttEnabled" active-text="开启"
										inactive-text="关闭"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>

					<!-- Tab 页签 5: * 话机与通话 -->
					<el-tab-pane label="* 话机与通话" name="callConfig" v-if="isBlogAdmin">
						<div class="tab-section-title"><i class="el-icon-phone-outline"></i> 通话业务配置</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="通话模式">
									<el-radio-group v-model="callMode">
										<el-radio label="wechat">微信电话</el-radio>
										<el-radio label="normal">普通电话</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="默认拨号模式">
									<el-radio-group v-model="dialMode">
										<el-radio label="family">亲情号</el-radio>
										<el-radio v-if="callMode !== 'wechat'" label="free">自由拨号</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="通话验证方式">
									<el-checkbox-group v-model="callVerifyMethod">
										<el-checkbox label="face">刷脸</el-checkbox>
										<el-checkbox label="card">刷卡</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="允许通话方式">
									<el-checkbox-group v-model="allowedCallTypes">
										<el-checkbox label="voice">语音通话</el-checkbox>
										<el-checkbox label="video">视频通话</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="单次通话时长">
									<el-input-number v-model="callTimeLimit" :min="0" :max="600"
										style="width:150px"></el-input-number>
									<span class="form-helper">分钟 (0为不限制)</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="通讯录自动退出">
									<el-input-number v-model="contactsAutoExitSeconds" :min="0" :max="3600"
										style="width:150px"></el-input-number>
									<span class="form-helper">秒 (0为不自动退出)</span>
								</el-form-item>
							</el-col>
						</el-row>

						<div class="tab-section-title" style="margin-top: 20px;"><i class="el-icon-headset"></i> 话机硬件控制
						</div>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="隐藏号码">
									<el-switch v-model="isHideCallNumber"></el-switch>
								</el-form-item>
							</el-col>
							<el-col :span="12" v-if="isHideCallNumber">
								<el-form-item label="隐藏规则">
									<span>起始</span> <el-input-number v-model="hideCallNumberStart" size="mini"
										style="width:90px;margin: 0 8px;"></el-input-number>
									<span>长度</span> <el-input-number v-model="hideCallNumberLen" size="mini"
										style="width:90px;margin-left: 8px;"></el-input-number>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="只能听筒接听">
									<el-switch v-model="handsetOnlyAnswer"></el-switch>
								</el-form-item>
							</el-col>
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitForm" v-if="!homeData.Id">前往排版</el-button>
				<el-button type="primary" @click="saveGrid(true)" v-if="homeData.Id">直接保存</el-button>
				<el-button type="primary" @click="submitForm"
					v-if="homeData.Id && pageMode !== 'StyleOne'">重新排版</el-button>
			</div>
		</el-dialog>

		<!-- 应用设备明细 -->
		<el-dialog title="应用设备明细" :visible.sync="equdialogVisible" width="40%">
			<el-input v-model="bindDeviceKeyword" placeholder="搜索设备号、设备名称或绑定班级" clearable prefix-icon="el-icon-search"
				style="margin-bottom: 12px" @input="onBindDeviceSearch" />
			<el-table :data="paginatedBindTerminalList" style="width: 100%" empty-text="未应用设备">
				<el-table-column label="设备号" prop="id"> </el-table-column>
				<el-table-column label="设备名称" prop="name">
				</el-table-column>
				<el-table-column label="绑定班级" prop="dept">
				</el-table-column>
			</el-table>
			<div slot="footer" v-if="bindDeviceTotal > 0" class="bind-device-dialog-footer">
				<el-pagination layout="total, prev, pager, next" :current-page.sync="bindDevicePage"
					:page-size="bindDevicePageSize" :total="bindDeviceTotal"
					@current-change="handleBindDevicePageChange" />
			</div>
		</el-dialog>

		<!-- 自定义组件添加弹窗 -->
		<el-dialog title="添加自定义组件" :visible.sync="addCustom" width="50%" @open="onAddCustomDialogOpen"
			@close="onAddCustomDialogClose">
			<el-form ref="customForm" :model="customForm" label-width="100px" :rules="formRules">
				<el-form-item label="组件名称" prop="detail">
					<el-input v-model="customForm.detail"></el-input>
				</el-form-item>
				<el-form-item label="媒体类型">
					<el-select v-model="customForm.mediaType" placeholder="请选择" @change="changeMediaType">
						<el-option label="图片" value="image"></el-option>
						<el-option label="视频" value="video"></el-option>
						<el-option label="链接" value="link"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面" v-if="customForm.mediaType != 'image'">
					<el-upload class="avatar-uploader" action="#" :auto-upload="false" accept="image/*"
						:show-file-list="false" :on-change="handleCoverChange">
						<img v-if="deferredImageDisplay('cover', coverUrl)"
							v-oss-src="deferredImageDisplay('cover', coverUrl)" class="avatar" />
						<i v-if="!deferredImageDisplay('cover', coverUrl)"
							class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<div v-if="customForm.mediaType != 'link'">
					<el-form-item label="上传媒体" prop="mediaUrl">
						<el-upload class="avatar-uploader" action="#"
							:accept="customForm.mediaType == 'image' ? 'image/*' : 'video/mp4'" :show-file-list="false"
							:http-request="customAddMediaUpload" :before-upload="beforeAddAvatarUpload">
							<img v-if="customForm.mediaType == 'image' && imageUrl" v-oss-src="imageUrl"
								class="avatar" />
							<video v-if="customForm.mediaType == 'video' && customVideoPreviewSrc"
								:src="customVideoPreviewSrc" class="avatar" controls />
							<i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
							<i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</div>
				<el-form-item label="是否在组件库中显示图片:" label-width="170px" v-if="customForm.mediaType == 'image'">
					<el-radio-group v-model="customForm.icon">
						<el-radio label="1">是</el-radio>
						<el-radio label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="链接" prop="mediaUrl" v-if="customForm.mediaType == 'link'">
					<el-input v-model="customForm.mediaUrl"></el-input>
				</el-form-item>
				<!-- 自定义组件霸屏 -->
				<el-form-item label="霸屏时间" prop="Times">
					<div v-for="(timeItem, index) in customForm.Times" :key="index" style="
								display: flex;
								flex-wrap: wrap;
								margin-bottom: 15px;
								padding: 10px;
								border: 1px solid #ebeef5;
								border-radius: 4px;
							">
						<el-date-picker v-model="customForm.Times[index]" type="datetimerange" start-placeholder="开始时间"
							end-placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
							value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						<el-button size="small" type="danger" @click="removeAutoTime(index, 'custom')">删除</el-button>
					</div>
					<el-button type="primary" @click="addAutoTime('custom')">添加时间</el-button>
				</el-form-item>
				<el-form-item label="最小宽度">
					<el-input-number v-model="customForm.minWidth" :min="10" :step="10"></el-input-number>
				</el-form-item>
				<el-form-item label="最小高度">
					<el-input-number v-model="customForm.minHeight" :min="10" :step="10"></el-input-number>
				</el-form-item>
				<el-form-item label="初始宽度">
					<el-input-number v-model="customForm.width" :min="10" :step="10"></el-input-number>
				</el-form-item>
				<el-form-item label="初始高度">
					<el-input-number v-model="customForm.height" :min="10" :step="10"></el-input-number>
				</el-form-item>
				<el-form-item label="文字颜色">
					<el-color-picker v-model="customForm.color" value-format="hex"></el-color-picker>
				</el-form-item>
				<el-form-item label="背景颜色">
					<el-color-picker v-model="customForm.background" value-format="hex"></el-color-picker>
				</el-form-item>
				<el-form-item label="锁定宽高比">
					<el-switch v-model="customForm.lockAspectRatio"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addCustom = false">取消</el-button>
				<el-button type="primary" @click="addCustomGrid" :loading="addCustomLoadding">确定</el-button>
			</span>
		</el-dialog>

		<!-- 视频上传进度 -->
		<el-dialog title="视频上传中" :visible.sync="videoUploading" :close-on-click-modal="false"
			:close-on-press-escape="false" :show-close="false" width="400px" append-to-body>
			<el-progress :percentage="videoUploadProgress" :stroke-width="16"></el-progress>
			<div style="text-align:center;margin-top:12px;color:#909399;font-size:13px;">请勿关闭或切换页面</div>
		</el-dialog>

		<!-- 管理动态字段 Schema 弹窗 -->
		<el-dialog title="管理动态配置字段" :visible.sync="dynamicSchemaDialogVisible" width="60%" append-to-body>
			<div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
				<el-radio-group v-model="schemaViewMode" size="small">
					<el-radio-button label="visual"><i class="el-icon-s-grid"></i> 可视化视图</el-radio-button>
					<el-radio-button label="json"><i class="el-icon-document"></i> JSON 源码视图</el-radio-button>
				</el-radio-group>
			</div>

			<div v-show="schemaViewMode === 'visual'">
				<el-button type="primary" size="mini" icon="el-icon-plus" style="margin-bottom: 10px;"
					@click="addDynamicSchemaItem">添加字段</el-button>
				<el-table :data="dynamicSchema" border style="width: 100%" size="small">
					<el-table-column label="字段标识 (Key)" width="180">
						<template #default="scope">
							<el-input v-model="scope.row.key" size="mini" placeholder="英文字母"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="显示标题 (Label)" width="180">
						<template #default="scope">
							<el-input v-model="scope.row.label" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="控件类型 (Type)" width="140">
						<template #default="scope">
							<el-select v-model="scope.row.type" size="mini">
								<el-option label="输入框 (Input)" value="input"></el-option>
								<el-option label="数字框 (Number)" value="number"></el-option>
								<el-option label="开关 (Switch)" value="switch"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="默认值" min-width="120">
						<template #default="scope">
							<el-switch v-if="scope.row.type === 'switch'" v-model="scope.row.defaultValue"></el-switch>
							<el-input-number v-else-if="scope.row.type === 'number'" v-model="scope.row.defaultValue"
								size="mini"></el-input-number>
							<el-input v-else v-model="scope.row.defaultValue" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="90" align="center">
						<template #default="scope">
							<el-button type="danger" icon="el-icon-delete" size="mini" circle
								@click="removeDynamicSchemaItem(scope.$index)"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div v-show="schemaViewMode === 'json'">
				<el-alert title="请确保 JSON 格式合法。包含 key, label, type, defaultValue 四个基本属性。" type="info" show-icon
					style="margin-bottom: 10px;"></el-alert>
				<el-input type="textarea" :rows="15" v-model="schemaJsonString"
					style="font-family: monospace;"></el-input>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dynamicSchemaDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveDynamicSchema">确定并应用</el-button>
			</span>
		</el-dialog>

		<!-- 新增/编辑个人空间自定义菜单弹窗 -->
		<el-dialog :title="isEditCustomMenu ? '编辑自定义菜单' : '新增自定义菜单'" :visible.sync="customMenuDialogVisible"
			width="650px" append-to-body>
			<el-form :model="customMenuForm" label-width="110px" :rules="customMenuRules" ref="customMenuFormRef">
				<el-form-item label="菜单名称" prop="title">
					<el-input v-model="customMenuForm.title" placeholder="如：智慧阅读、成长档案" maxlength="15"
						show-word-limit></el-input>
				</el-form-item>

				<el-form-item label="菜单图标" prop="icon">
					<el-upload class="custom-menu-icon-uploader" action="#" :auto-upload="false" :show-file-list="false"
						:on-change="handleCustomMenuIconChange" accept=".png, .jpg, .jpeg, .svg, .gif">
						<oss-el-image v-if="deferredImageDisplay('customMenuIcon', customMenuForm.icon)"
							:src="getMenuIconPath(deferredImageDisplay('customMenuIcon', customMenuForm.icon))"
							class="custom-menu-avatar" fit="contain">
							<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
						</oss-el-image>
						<i v-else class="el-icon-plus custom-menu-uploader-icon"></i>
					</el-upload>
					<div style="font-size: 12px; color: #909399; line-height: 1.5; margin-top: 5px;">
						点击虚线框上传或更改图标，推荐透明背景 PNG。<br />当前存值：{{ customMenuForm.icon || '未上传' }}
					</div>
				</el-form-item>

				<el-form-item label="链接地址" prop="target">
					<el-input v-model="customMenuForm.target"
						placeholder="如：https://reading.school.com/student"></el-input>
					<div style="font-size: 12px; color: #909399; margin-top: 4px;">
						仅支持以 http:// 或 https:// 开头的完整 Web 链接地址
					</div>
				</el-form-item>

				<el-form-item label="拼接识别数据">
					<div style="font-size: 12px; color: #909399; margin-bottom: 6px;">
						勾选需要拼接到 URL 的识别数据（数据来源：人脸/卡号识别结果）：
					</div>
					<el-checkbox-group v-model="customMenuForm.params">
						<el-checkbox v-for="item in personalSpaceParamOptions" :key="item.key" :label="item.key"
							style="margin-right: 15px; margin-bottom: 6px;">
							{{ item.label }} ({{ item.key }})
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>

				<el-form-item label="是否启用">
					<el-switch v-model="customMenuForm.show" active-text="开启" inactive-text="关闭"></el-switch>
				</el-form-item>

				<!-- 弹窗底部：最终 URL 预览 -->
				<div class="custom-menu-url-preview-card">
					<div class="preview-header">
						<span><i class="el-icon-view"></i> 最终 URL 预览 (模拟识别参数)</span>
						<el-tag size="mini" type="info">实时拼接</el-tag>
					</div>
					<div class="preview-content">
						{{ previewFinalUrl || '（请先填写以 http:// 或 https:// 开头的链接地址）' }}
					</div>
					<div class="preview-hint">
						* 班牌终端实际跳转时，上述参数名对应的值将由人脸或刷卡识别获得的学生真实信息动态注入。
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="customMenuDialogVisible = false">取 消</el-button>
				<el-button type="primary" :loading="savingCustomMenu" @click="saveCustomMenu">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { BaseApiUrl } from '../../api/base';
import { GetHomePageList, getHomePage, saveHomePage, DeleteHomePage, getCustomComponentList, addCustomComponent, deleteCustomComponent, BindKqTerminalHomePage } from '../../api/modules/misc';
import { getCplateTerminalListPage } from '../../api/modules/attendance';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import util from '../../../util/date'
import axios from 'axios'
import { appendSchIdToFormData, stripOssPresignParams } from '../../utils/ossMediaUpload'
import {
	attachLocalVideoFile,
	revokeLocalVideoPreview,
	ensureVideoUploaded,
	beginVideoUploadProgress,
	endVideoUploadProgress,
	createVideoUploadProgressHandlers,
} from '../../utils/ossVideoUpload'
import { resolveMediaUrl, resolvePlayableMediaUrl, applyPlayableMediaUrl } from '../../utils/mediaUrl'
import defaultGridsConfig from '@/../config/gridConfig.js'
import { defaultGrid, defaultPortraitGrid, getDevicePreset, getDefaultLayout, isDefaultPortrait } from '@/../config/templateEditorDefaults.js'
import superAdminMixin from '../../mixins/superAdminMixin'
import { resolveActiveSchoolId } from '../../utils/deptCascaderProps'


export default {
	name: 'modeIndex',
	components: {
		VueDraggableResizable,
		Toolbar,
	},
	mixins: [superAdminMixin],
	data() {
		return {
			BaseApiUrl: BaseApiUrl, //网络前缀
			weatherIcon: require('./img/weather.png'),
			coursesIcon: require('./img/courses.png'),
			deptInfoIcon: require('./img/deptInfo.png'),
			deptInfoAIcon: require('./img/deptInfoA.png'),
			attenIcon: require('./img/atten.png'),
			weekIcon: require('./img/week.png'),
			// 模板列表
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			DepartmentId: 0,
			isEdit: false,
			editDate: {}, // 编辑原始数据
			buttonList: [],
			filters: {},
			total: 0,
			page: 1,
			PageSize: 10,
			list: [],
			listLoading: false,
			tableBodyScrollHandler: null,
			_tableResizeObserver: null,
			dialogVisible: false,
			dialogActiveTab: 'basic', // 新增：弹窗当前活动标签页
			multipleSelection: [],
			equdialogVisible: false,
			bindDeviceKeyword: '',
			bindDevicePage: 1,
			bindDevicePageSize: 6,
			terminalSelectList: [],
			BindKqTerminalIds: [],

			// 模板编辑
			homeData: {
				TemplateName: '',
				IsDefault: '0',
				PreviewImage: '',
				IsPortrait: false,
				AutoTimes: [],
				BindKqTerminalIds: []
			},
			show: false,
			// 是否竖屏
			isPortrait: false,
			// 是否开启人脸考勤
			isOpenFaceAtten: true,
			// 是否开启显示照片
			isShowPhoto: true,
			// 首页作为屏保
			isHomeScreenSaver: false,
			// 开启个人空间
			isOpenPersonalSpace: false,
			// 开启底部导航栏
			isOpenBottomNav: false,
			// 统一设置考勤对象
			KqObject: '',
			// 统一设置考勤模式
			attenMode: '',
			// 考勤界面自动退出时间
			attenAutoExitTime: '30',
			// 考勤界面保持时间
			attenKeepTime: '15',
			// 屏保时间
			screenSaverTime: '5',

			// 统配新增参数
			pageMode: 'DefautModel',
			themeMode: 'themeDark',
			faceSearchThreshold: 72,
			faceLivenessThreshold: 70,
			faceLivenessGaThreshold: 85,
			faceRcMode: 1,
			faceSimilarityDelta: 5,
			faceLivenessEnabled: true,
			faceAlgorithmType: 'megvii',

			// 通话配置参数
			callMode: 'normal',
			dialMode: 'family',
			allowedCallTypes: ['voice', 'video'],
			callVerifyMethod: ['face'],
			callTimeLimit: 0,
			contactsAutoExitSeconds: 60,
			headphonePutDownAction: 'hangup',
			headphonePutUpScreenOn: false,
			isHideCallNumber: false,
			hideCallNumberStart: 3,
			hideCallNumberLen: 4,
			isUpgradeVideoIncoming: false,
			isDisableAllComingCall: false,
			handsetOnlyAnswer: false,

			mqttConfig: {
				serverUri: 'wss://web.yiqiba.xin/mqtt',
				username: 'admin',
				password: 'public',
				heartbeatInterval: 30,
				h5MqttEnabled: false
			},

			// 组件配置
			customConfig: {
				// 倒计时设置
				countdown: {
					type: 'day', // day / minute
					title: '',
					time: '',
				},
				// 个人空间设置
				personalSpace: {
					enableChat: true,
					enableOrder: true,
					enableMoral: true,
					customMenus: [],
				},
				// 首页德育模式设置
				homeMoralMode: {
					mode: 'mascot', // mascot: 吉祥物, fiveStar: 五星
				},
			},

			// 动态配置
			dynamicSchemaDialogVisible: false,
			schemaViewMode: 'visual',
			schemaJsonString: '[]',
			dynamicSchema: [],
			dynamicValues: {},

			// 个人空间自定义菜单相关状态
			customMenuDialogVisible: false,
			isEditCustomMenu: false,
			currentCustomMenuIndex: -1,
			savingCustomMenu: false,
			customMenuForm: {
				id: '',
				title: '',
				icon: '',
				type: 'web',
				target: '',
				params: [],
				show: true,
			},
			customMenuRules: {
				title: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
				target: [
					{ required: true, message: '请输入链接地址', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (!value) {
								return callback(new Error('请输入链接地址'));
							}
							const trimmed = value.trim();
							if (!/^https?:\/\//i.test(trimmed)) {
								return callback(new Error('链接地址必须以 http:// 或 https:// 开头'));
							}
							callback();
						},
						trigger: 'blur'
					}
				],
			},
			personalSpaceParamOptions: [
				{ label: '学生姓名', key: 'name', field: 'Name', sample: '张三' },
				{ label: '学生ID', key: 'userId', field: 'UserId', sample: '640972415225925' },
				{ label: '卡号', key: 'cardNumber', field: 'CardNumber', sample: '387895283' },
				{ label: '班级ID', key: 'deptId', field: 'DeptId', sample: '639913678434373' },
				{ label: '班级名称', key: 'deptName', field: 'DeptName', sample: '高一(1)班' },
				{ label: '学号', key: 'stuCode', field: 'StuCode', sample: '2026001' },
				{ label: '第三方识别码', key: 'thirdPartyCode', field: 'ThirdPartyCode', sample: 'ding_abc123' },
				{ label: '考勤终端号', key: 'terminalId', field: 'TerminalId', sample: '1747579864239' },
				{ label: '学校ID', key: 'schoolId', field: 'SchoolId', sample: '1002' },
			],

			designWidth: 1920,
			designHeight: 1080,
			navHeight: 0,
			isLoadingTemplate: false,

			// 页面宽度
			pageWidth: 192,
			// 页面高度
			pageHeight: 108,

			selectIndex: -1,


			// 拖拽相关
			mouseXY: { x: null, y: null },
			layout: JSON.parse(JSON.stringify(defaultGrid)),

			activeName: 'defaultGrids',
			// 组件列表：从统一配置文件获取
			defaultGrids: defaultGridsConfig,
			addCustom: false,
			addCustomLoadding: false,
			customForm: {
				detail: '',
				icon: '1',
				mediaType: 'image',
				mediaUrl: '',
				Times: [],
				minWidth: 100,
				minHeight: 100,
				width: 300,
				height: 300,
				color: '#000',
				background: '#fff',
				lockAspectRatio: false,
				border: true,
			},
			formRules: {
				TemplateName: [
					{ required: true, message: '请输入模板名称', trigger: 'blur' },
				],
				detail: [
					{ required: true, message: '请输入组件名称', trigger: 'blur' },
				],
				mediaUrl: [
					{
						trigger: 'blur',
						required: true,
						/** 视频延迟上传时 mediaUrl 为空，需认 pendingVideoFile。最后更新：2026-07-17 */
						validator: (rule, value, callback) => {
							if (this.customForm.mediaType == 'link') {
								if (!value) {
									callback(new Error('请输入链接'))
									return
								} else {
									if (
										!/^https?:\/\/.+\..+/.test(value) &&
										!/^http?:\/\/.+\..+/.test(value)
									) {
										callback(new Error('请输入正确的链接'))
										return
									}
								}
							} else if (this.customForm.mediaType === 'video') {
								const hasVideo = this.pendingVideoFile || (value || this.imageUrl || '').toString().trim()
								if (!hasVideo) {
									callback(new Error('请上传媒体文件'))
									return
								}
							} else if (!value) {
								callback(new Error('请上传媒体文件'))
								return
							}
							callback()
						},
					},
				],
				AutoTimes: [
					{
						trigger: 'blur',
						validator: (rule, value, callback) => {
							for (let i = 0; i < value.length; i++) {
								if (!value[i].startTime) {
									callback(new Error(`第 ${i + 1} 组的开始时间未填写`))
									return
								}
								if (!value[i].endTime) {
									callback(new Error(`第 ${i + 1} 组的结束时间未填写`))
									return
								}
							}
							callback()
						},
					},
				],
				Times: [
					{
						trigger: 'blur',
						validator: (rule, value, callback) => {
							for (let i = 0; i < value.length; i++) {
								if (!value[i]) {
									callback(new Error(`第 ${i + 1} 组的时间未填写`))
									return
								}
							}
							callback()
						},
					},
				],
			},
			coverUrl: '', // 编辑用
			coverLoadding: false,
			imageUrl: '', // 编辑用
			imageLoadding: false,
			customGrids: [],
			pendingVideoFile: null,
			pendingVideoPreviewUrl: '',
			customVideoPlaySrc: '',
			videoUploading: false,
			videoUploadProgress: 0,
		}
	},
	computed: {
		/** 个人空间自定义菜单：实时最终 URL 预览 */
		previewFinalUrl() {
			const target = (this.customMenuForm.target || '').trim();
			if (!target) return '';
			const params = this.customMenuForm.params || [];
			if (!params.length) return target;

			const queryParts = [];
			params.forEach(key => {
				const opt = this.personalSpaceParamOptions.find(o => o.key === key);
				const val = opt ? opt.sample : 'test';
				queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
			});
			const queryString = queryParts.join('&');
			if (!queryString) return target;
			return target.includes('?') ? `${target}&${queryString}` : `${target}?${queryString}`;
		},
		/** 顶部当前学校 ID，模板按学校维度配置 */
		currentSchoolId() {
			return resolveActiveSchoolId(this)
		},
		schoolDisplayName() {
			return this.$store.state.activeSchoolName
				|| window.localStorage.getItem('activeSchoolName')
				|| ''
		},
		customVideoPreviewSrc() {
			if (this.customForm.mediaType !== 'video') return this.resolveMediaUrl(this.imageUrl)
			if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
			return this.customVideoPlaySrc || this.resolveMediaUrl(this.imageUrl || this.customForm.mediaUrl)
		},
		action() {
			return `${this.BaseApiUrl}${this.customForm.mediaType == 'image'
				? '/images/Upload/Pic'
				: '/images/Upload/Video'
				}`
		},
		grids() {
			return this[`${this.activeName}`] || []
		},
		terminalSelectListMap() {
			let map = new Map()
			this.terminalSelectList.forEach((item) => {
				map.set(item.TerminalId, item)
			})
			return map
		},
		/** 应用设备穿梭框选项（主行班级/名称 + 副行设备号） */
		terminalTransferOptions() {
			return this.terminalSelectList.map((item) => this.buildTerminalTransferOption(item))
		},
		showBindTerminalName() {
			return this.BindKqTerminalIds.map((id) => {
				return {
					name: this.terminalSelectListMap.get(id)
						? this.terminalSelectListMap.get(id).TerminalName || ''
						: '',
					id: id,
					dept: this.terminalSelectListMap.get(id)
						? this.terminalSelectListMap.get(id).AuthDeptName || ''
						: '',
				}
			}).sort((a, b) => {
				return a.dept.localeCompare(b.dept, 'zh-CN')
			})
		},
		/** 按关键字过滤后的设备明细 */
		filteredBindTerminalList() {
			const keyword = (this.bindDeviceKeyword || '').trim().toLowerCase()
			if (!keyword) {
				return this.showBindTerminalName
			}
			return this.showBindTerminalName.filter((item) => {
				const id = (item.id || '').toLowerCase()
				const name = (item.name || '').toLowerCase()
				const dept = (item.dept || '').toLowerCase()
				return id.includes(keyword) || name.includes(keyword) || dept.includes(keyword)
			})
		},
		/** 当前页展示的设备明细 */
		paginatedBindTerminalList() {
			const start = (this.bindDevicePage - 1) * this.bindDevicePageSize
			return this.filteredBindTerminalList.slice(start, start + this.bindDevicePageSize)
		},
		bindDeviceTotal() {
			return this.filteredBindTerminalList.length
		},
		navDeviceHeight() {
			return this.navHeight || (this.isPortrait ? 112 : 63);
		},
	},
	watch: {
		currentSchoolId: {
			immediate: true,
			handler(val) {
				this.DepartmentId = val || 0
				if (val) {
					this.page = 1
					this.handleQuery()
				} else {
					this.list = []
					this.total = 0
					this.terminalSelectList = []
				}
			},
		},
		isPortrait(val) {
			// 如果处于模板加载状态，或者当前不在排版编辑模式中，禁止重置分辨率和布局
			if (this.isLoadingTemplate || !this.isEdit) {
				return
			}
			this.selectIndex = -1
			this.designWidth = val ? 1080 : 1920
			this.designHeight = val ? 1920 : 1080
			this.$nextTick(() => {
				this.layout = JSON.parse(
					JSON.stringify(val ? defaultPortraitGrid : defaultGrid)
				)
				this.init()
			})
		},
		designWidth(val) {
			if (this.isEdit) {
				this.init()
			}
		},
		designHeight(val) {
			if (this.isEdit) {
				this.init()
			}
		},
		navHeight(val) {
			if (this.isEdit) {
				this.init()
			}
		},
		isOpenBottomNav(val) {
			if (this.isEdit) {
				this.init()
			}
		},
		addCustom(val) {
			if (!val) {
				this.coverUrl = ''
				this.deferredImageRevoke('cover')
				this.imageUrl = ''
				this.customForm = {
					detail: '',
					icon: '1',
					mediaType: 'image',
					mediaUrl: '',
					Times: [],
					minWidth: 100,
					minHeight: 100,
					width: 300,
					height: 300,
					color: '#000',
					lockAspectRatio: false,
					border: true,
				}
			}
		},
		isEdit(val) {
			if (val) {
				this.teardownListTableResizeObserver()
				this.unbindTableHeaderScrollSync()
				this.$nextTick(() => {
					this.onload()
				})
			} else {
				this.$nextTick(() => {
					this.setupListTableResizeObserver()
					this.layoutListTable()
				})
			}
		},
		listLoading(val) {
			if (!val && !this.isEdit) {
				this.layoutListTable()
			}
		},
		// 倒计时类型改变时，目标时间格式也需要改变
		'customConfig.countdown.type'(val) {
			if (this.customConfig.countdown.time) {
				let date = new Date(this.customConfig.countdown.time)
				if (val == 'day') {
					this.customConfig.countdown.time = util.formatDate.format(
						date,
						'yyyy-MM-dd'
					)
				} else {
					this.customConfig.countdown.time = util.formatDate.format(
						date,
						'yyyy-MM-dd hh:mm:ss'
					)
				}
			}
		},
	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)

		window.onresize = () => {
			if (this.isEdit) {
				this.init()
			} else {
				this.layoutListTable()
			}
		}

		// 拖拽监听
		window.addEventListener(
			'dragover',
			(e) => {
				this.mouseXY.x = e.clientX
				this.mouseXY.y = e.clientY
			},
			false
		)

		// 键盘监听键盘微调组件位置
		window.addEventListener('keydown', this.handleKeyDown)

		this.$nextTick(() => {
			if (!this.isEdit) {
				this.setupListTableResizeObserver()
				this.layoutListTable()
			}
		})
	},
	beforeDestroy() {
		window.onresize = () => { }
		window.removeEventListener('dragover', this.dragOver)
		window.removeEventListener('keydown', this.handleKeyDown)
		this.teardownListTableResizeObserver()
		this.unbindTableHeaderScrollSync()
	},
	methods: {
		resolveMediaUrl,
		openDynamicSchemaDialog() {
			this.schemaJsonString = JSON.stringify(this.dynamicSchema, null, 2)
			this.schemaViewMode = 'visual'
			this.dynamicSchemaDialogVisible = true
		},
		addDynamicSchemaItem() {
			this.dynamicSchema.push({
				key: 'newField' + new Date().getTime(),
				label: '新增配置',
				type: 'input',
				defaultValue: ''
			})
		},
		removeDynamicSchemaItem(index) {
			this.dynamicSchema.splice(index, 1)
		},
		saveDynamicSchema() {
			if (this.schemaViewMode === 'json') {
				try {
					this.dynamicSchema = JSON.parse(this.schemaJsonString)
				} catch (e) {
					this.$message.error('JSON 格式不正确')
					return
				}
			}
			let newValues = {}
			this.dynamicSchema.forEach(item => {
				if (this.dynamicValues[item.key] !== undefined) {
					newValues[item.key] = this.dynamicValues[item.key]
				} else {
					newValues[item.key] = item.defaultValue
				}
			})
			this.dynamicValues = newValues
			this.dynamicSchemaDialogVisible = false
			this.$message.success('动态字段应用成功')
		},
		async customAddMediaUpload(req) {
			const { file, onSuccess, onError } = req
			if (!this.currentSchoolId) {
				this.$message.warning('请先在顶部选择学校')
				onError(new Error('未选择学校'))
				this.imageLoadding = false
				return
			}
			try {
				if (this.customForm.mediaType === 'image') {
					const formData = new FormData()
					formData.append('Files', file)
					formData.append('Foo', 'ModeIndex')
					appendSchIdToFormData(formData, this)
					const res = await axios.post(`${this.BaseApiUrl}/images/Upload/Pic`, formData, {
						headers: { 'Content-Type': 'multipart/form-data' },
					})
					const body = res.data
					if (!body || !body.success) {
						throw new Error((body && body.msg) || '上传失败')
					}
					let url = body.response != null ? body.response : body.Response
					if (Array.isArray(url)) url = url[0]
					if (typeof url === 'string' && url.indexOf(';') >= 0) {
						url = url.split(';')[0]
					}
					url = stripOssPresignParams(url || '')
					this.imageUrl = url
					this.customForm.mediaUrl = url
					onSuccess(body)
				} else {
					this.revokePendingVideoLocal()
					const local = attachLocalVideoFile(file)
					this.pendingVideoFile = local.pendingVideoFile
					this.pendingVideoPreviewUrl = local.pendingVideoPreviewUrl
					this.imageUrl = this.pendingVideoPreviewUrl
					this.imageLoadding = false
					if (this.$refs.customForm) this.$refs.customForm.validateField('mediaUrl')
					onSuccess({ success: true, response: '' })
					return
				}
				this.imageLoadding = false
			} catch (e) {
				this.imageLoadding = false
				this.$message.error((e && e.message) || '上传失败')
				onError(e)
			}
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		/** 修正列表表头/表体列宽，并绑定横向滚动同步。最后更新：2026-08-31 */
		layoutListTable() {
			const runLayout = () => {
				const table = this.$refs.table
				if (!table || typeof table.doLayout !== 'function') return
				table.doLayout()
				this.bindTableHeaderScrollSync()
			}
			this.$nextTick(runLayout)
			setTimeout(runLayout, 120)
			setTimeout(runLayout, 320)
		},
		bindTableHeaderScrollSync() {
			const table = this.$refs.table
			const body = table && table.bodyWrapper
			if (!body) return
			this.unbindTableHeaderScrollSync()
			this.tableBodyScrollHandler = () => {
				const header = table.$refs && table.$refs.headerWrapper
				if (header) {
					header.scrollLeft = body.scrollLeft
				}
				if (typeof table.syncPostion === 'function') {
					table.syncPostion()
				}
			}
			body.addEventListener('scroll', this.tableBodyScrollHandler, { passive: true })
		},
		unbindTableHeaderScrollSync() {
			const table = this.$refs.table
			const body = table && table.bodyWrapper
			if (body && this.tableBodyScrollHandler) {
				body.removeEventListener('scroll', this.tableBodyScrollHandler)
			}
			this.tableBodyScrollHandler = null
		},
		setupListTableResizeObserver() {
			this.teardownListTableResizeObserver()
			const el = this.$refs.tableScrollWrap
			if (!el || typeof ResizeObserver === 'undefined') return
			this._tableResizeObserver = new ResizeObserver(() => {
				this.layoutListTable()
			})
			this._tableResizeObserver.observe(el)
		},
		teardownListTableResizeObserver() {
			if (this._tableResizeObserver) {
				this._tableResizeObserver.disconnect()
				this._tableResizeObserver = null
			}
		},
		handleRowClick(row) {
			const index = this.multipleSelection.indexOf(row);
			if (index > -1) {
				this.multipleSelection.splice(index, 1);
			} else {
				this.multipleSelection = [row];
			}
		},
		onBindDeviceClick(row) {
			this.BindKqTerminalIds = row.BindKqTerminalIds || []
			this.bindDeviceKeyword = ''
			this.bindDevicePage = 1
			this.equdialogVisible = true
		},
		onBindDeviceSearch() {
			this.bindDevicePage = 1
		},
		handleBindDevicePageChange(page) {
			this.bindDevicePage = page
		},
		addAutoTime(type = '') {
			if (type === 'layout') {
				let temp = { ...this.layout[this.selectIndex] }
				if (!temp.Times) {
					temp.Times = []
				}
				temp.Times.push(['', ''])
				this.$set(this.layout, this.selectIndex, temp)
			} else if (type === 'custom') {
				this.customForm.Times.push('')
			} else {
				this.homeData.AutoTimes.push({
					startTime: '',
					endTime: '',
				})
			}
		},
		removeAutoTime(index, type = '') {
			if (type === 'layout') {
				let temp = { ...this.layout[this.selectIndex] }
				temp.Times.splice(index, 1)
				this.$set(this.layout, this.selectIndex, temp)
			} else if (type === 'custom') {
				this.customForm.Times.splice(index, 1)
			} else {
				this.homeData.AutoTimes.splice(index, 1)
			}
		},
		getLayoutTimePoint(timeItem, pointIndex) {
			if (!Array.isArray(timeItem)) return ''
			return timeItem[pointIndex] || ''
		},
		updateLayoutTimePoint(timeIndex, pointIndex, value) {
			if (this.selectIndex === -1) return
			let temp = { ...this.layout[this.selectIndex] }
			if (!Array.isArray(temp.Times)) {
				temp.Times = []
			}
			const current = Array.isArray(temp.Times[timeIndex]) ? [...temp.Times[timeIndex]] : ['', '']
			current[pointIndex] = value || ''
			temp.Times.splice(timeIndex, 1, current)
			this.$set(this.layout, this.selectIndex, temp)
		},
		handleTimeChange(val, item, type) {
			if (type == 'startTime') {
				this.$set(item, 'startTime', val)
				// 清空结束时间
				this.$set(item, 'endTime', '')
			}
		},
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})
				return
			}
			this.$confirm('确定删除选中项吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(async () => {
					let re = await DeleteHomePage({
						id: row[0].Id,
					})
					if (re) {
						if (re.status == 200 && re.data.status == 200) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
							this.handleQuery()
						}
					}
				})
				.catch(() => { })
		},
		handleDelRow(row) {
			this.multipleSelection = [row]
			this.handleDel()
		},
		handleEditRow(row) {
			this.multipleSelection = [row]
			this.handleEdit()
		},
		async handleCopy(row) {
			this.$confirm(`确定要复制模板 \"${row.TemplateName}\" 吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info',
			}).then(async () => {
				const loading = this.$loading({
					text: '正在复制模板...',
					lock: true,
					background: 'rgba(0, 0, 0, 0.7)',
				})
				try {
					let detailRes = await getHomePage({ id: row.Id })
					if (!detailRes || detailRes.status !== 200 || detailRes.data.status !== 200) {
						throw new Error((detailRes && detailRes.data && detailRes.data.msg) || '获取模板详情失败')
					}
					let detail = detailRes.data.response
					if (!detail) {
						throw new Error('未找到模板详情')
					}

					let page = {
						DepartmentId: this.DepartmentId,
						TemplateName: `${detail.TemplateName} - 副本`,
						IsDefault: false,
						BindKqTerminalIds: [], // 副本不绑定终端
						AutoTimes: detail.AutoTimes || '[]',
						IsPortrait: detail.IsPortrait || false,
						OtherConfig: detail.OtherConfig || '',
					}

					let grids = []
					if (detail.GridsJson) {
						try {
							grids = JSON.parse(detail.GridsJson)
						} catch (e) { }
					} else if (detail.Grids) {
						grids = detail.Grids
					}
					page.Grids = grids

					var user = JSON.parse(window.localStorage.user)
					if (user && user.uID > 0) {
						page.CreateBy = user.uRealName
					} else {
						throw new Error('用户信息为空，请先登录')
					}

					let res = await saveHomePage(page)
					if (res && res.status == 200 && res.data.status == 200) {
						this.$message({
							message: '模板复制成功',
							type: 'success',
						})
						this.handleQuery()
					} else {
						throw new Error((res && res.data && res.data.msg) || '保存复制模板失败')
					}
				} catch (e) {
					this.$message.error(e.message || '复制失败')
				} finally {
					loading.close()
				}
			}).catch(() => { })
		},
		handleDialogPortraitChange(val) {
			this.isPortrait = val
			// 若当前是默认分辨率或为空，切换到对应方向默认分辨率
			const isDefaultLandscape = Number(this.designWidth) === 1920 && Number(this.designHeight) === 1080
			const isDefaultPortrait = Number(this.designWidth) === 1080 && Number(this.designHeight) === 1920
			if (val) {
				// 切换为竖屏
				if (isDefaultLandscape || !this.designWidth || !this.designHeight) {
					this.designWidth = 1080
					this.designHeight = 1920
				} else if (Number(this.designWidth) > Number(this.designHeight)) {
					// 自定义分辨率且宽大于高，自动对调宽高
					const temp = this.designWidth
					this.designWidth = this.designHeight
					this.designHeight = temp
				}
			} else {
				// 切换为横屏
				if (isDefaultPortrait || !this.designWidth || !this.designHeight) {
					this.designWidth = 1920
					this.designHeight = 1080
				} else if (Number(this.designWidth) < Number(this.designHeight)) {
					// 自定义分辨率且宽小于高，自动对调宽高
					const temp = this.designWidth
					this.designWidth = this.designHeight
					this.designHeight = temp
				}
			}
		},
		handleAdd() {
			if (!this.currentSchoolId) {
				this.$message.warning('请先在顶部选择学校')
				return
			}
			this.isLoadingTemplate = true
			this.homeData = {
				TemplateName: '',
				IsDefault: '0',
				BindKqTerminalIds: [],
				AutoTimes: [],
				IsPortrait: false,
			}
			this.isPortrait = false
			this.designWidth = 1920
			this.designHeight = 1080
			this.dialogActiveTab = 'basic'

			// 初始化全局及考勤参数
			this.pageMode = 'DefautModel'
			this.themeMode = 'themeDark'
			this.isHomeScreenSaver = false
			this.screenSaverTime = 5
			this.isOpenBottomNav = true
			this.isOpenFaceAtten = true
			this.isShowPhoto = true
			this.isOpenPersonalSpace = true
			this.KqObject = ''
			this.attenMode = ''
			this.attenAutoExitTime = 30
			this.attenKeepTime = 15

			this.dynamicSchema = []
			this.dynamicValues = {}

			// 初始化算法高级参数
			this.faceSearchThreshold = 72
			this.faceLivenessThreshold = 70
			this.faceLivenessGaThreshold = 85
			this.faceRcMode = 1
			this.faceSimilarityDelta = 5
			this.faceLivenessEnabled = true
			this.faceAlgorithmType = 'megvii'

			// 初始化 MQTT
			this.mqttConfig = {
				serverUri: 'wss://web.yiqiba.xin/mqtt',
				username: 'admin',
				password: 'public',
				heartbeatInterval: 30,
				h5MqttEnabled: false
			}

			// 初始化通话配置
			this.callMode = 'normal'
			this.dialMode = 'family'
			this.allowedCallTypes = ['voice', 'video']
			this.callVerifyMethod = ['face']
			this.callTimeLimit = 0
			this.contactsAutoExitSeconds = 60
			this.headphonePutDownAction = 'hangup'
			this.headphonePutUpScreenOn = false
			this.isHideCallNumber = false
			this.hideCallNumberStart = 3
			this.hideCallNumberLen = 4
			this.isUpgradeVideoIncoming = false
			this.isDisableAllComingCall = false
			this.handsetOnlyAnswer = false

			this.customConfig = {
				countdown: { type: 'day', title: '', time: '' },
				personalSpace: { enableChat: true, enableOrder: true, enableMoral: true, customMenus: [] },
				homeMoralMode: { mode: 'mascot' }
			}

			this.dialogVisible = true
			this.$nextTick(() => {
				this.isLoadingTemplate = false
			})
		},
		async handleEdit() {
			let row = this.multipleSelection
			if (!row || row.length == 0) {
				this.$message({
					message: '请选择要编辑的数据！',
					type: 'error',
				})
				return
			}
			this.isLoadingTemplate = true
			const targetRow = row[0]
			this.editDate = targetRow
			let temp = JSON.parse(JSON.stringify(targetRow))

			const loading = this.$loading({
				text: '正在加载模板配置...',
				lock: true,
				background: 'rgba(0, 0, 0, 0.7)',
			})

			try {
				if (targetRow.Id) {
					let res = await getHomePage({ id: targetRow.Id })
					if (res && res.status === 200 && res.data && res.data.status === 200 && res.data.response) {
						const detail = res.data.response
						temp = Object.assign({}, detail, temp)
						if (detail.OtherConfig) {
							temp.OtherConfig = detail.OtherConfig
						}
						if (detail.GridsJson) {
							temp.GridsJson = detail.GridsJson
						}
						if (detail.Grids) {
							temp.Grids = detail.Grids
						}
					}
				}
			} catch (e) {
				console.error('获取模板详情异常:', e)
			} finally {
				loading.close()
			}

			temp.IsDefault = (targetRow.IsDefault === true || targetRow.IsDefault === '1' || targetRow.IsDefault === 1) ? '1' : '0'
			if (!temp.Grids) {
				try {
					let tempg = typeof temp.GridsJson === 'string' ? JSON.parse(temp.GridsJson) : temp.GridsJson
					if (Array.isArray(tempg)) {
						temp.Grids = tempg.sort((a, b) => a.i - b.i)
					}
				} catch (error) { }
			}
			if (!temp.AutoTimes) {
				temp.AutoTimes = []
			} else if (typeof temp.AutoTimes === 'string') {
				try {
					temp.AutoTimes = JSON.parse(temp.AutoTimes)
				} catch (e) {
					temp.AutoTimes = []
				}
			}

			const isPort = temp.IsPortrait === true || temp.IsPortrait === '1' || temp.IsPortrait === 1
			this.homeData = temp
			this.homeData.IsPortrait = isPort
			this.isPortrait = isPort
			this.dialogActiveTab = 'basic'

			// 解析 OtherConfig
			let other = {}
			if (temp.OtherConfig) {
				if (typeof temp.OtherConfig === 'object') {
					other = temp.OtherConfig
				} else if (typeof temp.OtherConfig === 'string') {
					try {
						other = JSON.parse(temp.OtherConfig)
					} catch (error) {
						console.error('解析 OtherConfig 失败:', error)
					}
				}
			}
			this.isHomeScreenSaver = other.isHomeScreenSaver === true ? true : false
			this.isOpenFaceAtten = other.isOpenFaceAtten === false ? false : true
			this.isShowPhoto = other.isShowPhoto === false ? false : true
			this.isOpenPersonalSpace = other.isOpenPersonalSpace === false ? false : true
			this.isOpenBottomNav = other.isOpenBottomNav === false ? false : true
			this.navHeight = Number(other.navHeight) || 0
			this.KqObject = other.KqObject || ''
			this.attenMode = other.attenMode || ''
			this.attenAutoExitTime = other.attenAutoExitTime || '30'
			this.attenKeepTime = other.attenKeepTime || '15'
			this.screenSaverTime = other.screenSaverTime || '5'

			// 优先读取已保存的自定义分辨率，避免回退成默认分辨率
			if (other.designWidth !== undefined && other.designWidth !== null && other.designWidth !== '') {
				this.designWidth = Number(other.designWidth)
			} else {
				this.designWidth = isPort ? 1080 : 1920
			}
			if (other.designHeight !== undefined && other.designHeight !== null && other.designHeight !== '') {
				this.designHeight = Number(other.designHeight)
			} else {
				this.designHeight = isPort ? 1920 : 1080
			}

			this.pageMode = other.pageMode || 'DefautModel'
			this.themeMode = other.themeMode || 'themeDark'
			this.faceSearchThreshold = other.faceSearchThreshold !== undefined ? other.faceSearchThreshold : 72
			this.faceLivenessThreshold = other.faceLivenessThreshold !== undefined ? other.faceLivenessThreshold : 70
			this.faceLivenessGaThreshold = other.faceLivenessGaThreshold !== undefined ? other.faceLivenessGaThreshold : 85
			this.faceRcMode = other.faceRcMode !== undefined ? other.faceRcMode : 1
			this.faceSimilarityDelta = other.faceSimilarityDelta !== undefined ? other.faceSimilarityDelta : 5
			this.faceLivenessEnabled = other.faceLivenessEnabled !== false ? true : false
			this.faceAlgorithmType = other.faceAlgorithmType || 'megvii'

			// 通话配置解析
			this.callMode = other.callMode || 'normal'
			this.dialMode = other.dialMode || 'family'
			this.allowedCallTypes = other.allowedCallTypes || ['voice', 'video']
			this.callVerifyMethod = other.callVerifyMethod || ['face']
			this.callTimeLimit = other.callTimeLimit !== undefined ? other.callTimeLimit : 0
			this.contactsAutoExitSeconds = other.contactsAutoExitSeconds !== undefined ? other.contactsAutoExitSeconds : 60
			this.headphonePutDownAction = other.headphonePutDownAction || 'hangup'
			this.headphonePutUpScreenOn = other.headphonePutUpScreenOn === true
			this.isHideCallNumber = other.isHideCallNumber === true
			this.hideCallNumberStart = other.hideCallNumberStart !== undefined ? other.hideCallNumberStart : 3
			this.hideCallNumberLen = other.hideCallNumberLen !== undefined ? other.hideCallNumberLen : 4
			this.isUpgradeVideoIncoming = other.isUpgradeVideoIncoming === true
			this.isDisableAllComingCall = other.isDisableAllComingCall === true
			this.handsetOnlyAnswer = other.handsetOnlyAnswer === true

			if (other.mqttConfig) {
				this.mqttConfig = {
					serverUri: other.mqttConfig.serverUri || 'wss://web.yiqiba.xin/mqtt',
					username: other.mqttConfig.username || 'admin',
					password: other.mqttConfig.password || 'public',
					heartbeatInterval: other.mqttConfig.heartbeatInterval !== undefined ? other.mqttConfig.heartbeatInterval : 30,
					h5MqttEnabled: other.mqttConfig.h5MqttEnabled === true ? true : false
				}
			} else {
				this.mqttConfig = {
					serverUri: 'wss://web.yiqiba.xin/mqtt',
					username: 'admin',
					password: 'public',
					heartbeatInterval: 30,
					h5MqttEnabled: false
				}
			}
			this.customConfig = {
				countdown:
					other.customConfig && other.customConfig.countdown
						? other.customConfig.countdown
						: {
							title: '',
							time: '',
							type: 'day',
						},
				personalSpace:
					other.customConfig && other.customConfig.personalSpace
						? {
							enableChat: other.customConfig.personalSpace.enableChat !== false,
							enableOrder: other.customConfig.personalSpace.enableOrder !== false,
							enableMoral: other.customConfig.personalSpace.enableMoral !== false,
							customMenus: Array.isArray(other.customConfig.personalSpace.customMenus)
								? other.customConfig.personalSpace.customMenus
								: [],
						}
						: {
							enableChat: true,
							enableOrder: true,
							enableMoral: true,
							customMenus: [],
						},
				homeMoralMode:
					other.customConfig && other.customConfig.homeMoralMode
						? other.customConfig.homeMoralMode
						: {
							mode: 'mascot',
						},
			}

			this.dynamicSchema = other.dynamicSchema || []
			this.dynamicValues = other.dynamicValues || {}

			this.dialogVisible = true
			this.$nextTick(() => {
				this.isLoadingTemplate = false
			})
		},
		buildOtherConfig() {
			const isPort = this.homeData.IsPortrait === true || this.homeData.IsPortrait === '1' || this.homeData.IsPortrait === 1 || this.isPortrait
			const defaultW = isPort ? 1080 : 1920
			const defaultH = isPort ? 1920 : 1080
			const finalW = Number(this.designWidth) > 0 ? Number(this.designWidth) : defaultW
			const finalH = Number(this.designHeight) > 0 ? Number(this.designHeight) : defaultH

			return JSON.stringify({
				isHomeScreenSaver: this.isHomeScreenSaver,
				isOpenFaceAtten: this.isOpenFaceAtten,
				isShowPhoto: this.isShowPhoto,
				isOpenPersonalSpace: this.isOpenPersonalSpace,
				isOpenBottomNav: this.isOpenBottomNav,
				navHeight: Number(this.navHeight) || 0,
				KqObject: this.KqObject,
				attenMode: this.attenMode,
				attenAutoExitTime: this.attenAutoExitTime,
				attenKeepTime: this.attenKeepTime,
				screenSaverTime: this.screenSaverTime,
				customConfig: this.customConfig,
				pageMode: this.pageMode,
				themeMode: this.themeMode,
				faceSearchThreshold: this.faceSearchThreshold,
				faceLivenessThreshold: this.faceLivenessThreshold,
				faceLivenessGaThreshold: this.faceLivenessGaThreshold,
				faceRcMode: this.faceRcMode,
				faceSimilarityDelta: this.faceSimilarityDelta,
				faceLivenessEnabled: this.faceLivenessEnabled,
				faceAlgorithmType: this.faceAlgorithmType,
				callMode: this.callMode,
				dialMode: this.dialMode,
				allowedCallTypes: this.allowedCallTypes,
				callVerifyMethod: this.callVerifyMethod,
				callTimeLimit: this.callTimeLimit,
				contactsAutoExitSeconds: this.contactsAutoExitSeconds,
				headphonePutDownAction: this.headphonePutDownAction,
				headphonePutUpScreenOn: this.headphonePutUpScreenOn,
				isHideCallNumber: this.isHideCallNumber,
				hideCallNumberStart: this.hideCallNumberStart,
				hideCallNumberLen: this.hideCallNumberLen,
				isUpgradeVideoIncoming: this.isUpgradeVideoIncoming,
				isDisableAllComingCall: this.isDisableAllComingCall,
				handsetOnlyAnswer: this.handsetOnlyAnswer,
				mqttConfig: this.mqttConfig,
				designWidth: finalW,
				designHeight: finalH,
				dynamicSchema: this.dynamicSchema,
				dynamicValues: this.dynamicValues,
			})
		},
		submitForm() {
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.isPortrait = this.homeData.IsPortrait === true || this.homeData.IsPortrait === '1' || this.homeData.IsPortrait === 1
					this.homeData.OtherConfig = this.buildOtherConfig()
					this.dialogVisible = false
					this.isEdit = true
				}
			})
		},
		//获取列表
		async handleQuery() {
			if (!this.currentSchoolId) {
				this.list = []
				this.total = 0
				this.listLoading = false
				return
			}
			this.DepartmentId = this.currentSchoolId
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			GetHomePageList(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.list = res.data.response.data
				this.listLoading = false
				this.layoutListTable()
			})

			this.getCplateTerminalList()
		},
		buildTerminalTransferOption(item) {
			const terminalId = item.TerminalId || ''
			const terminalName = item.TerminalName || ''
			const dept = item.AuthDeptName || ''
			const mainText = dept || terminalName || terminalId
			let subText = ''
			if (dept && terminalId && terminalId !== dept) {
				subText = terminalId
			} else if (!dept && terminalName && terminalId && terminalName !== terminalId) {
				subText = terminalId
			}
			return {
				key: terminalId,
				label: [mainText, subText, terminalName, terminalId].filter(Boolean).join(' '),
				mainText,
				subText,
			}
		},
		renderTerminalTransferItem(h, option) {
			const mainText = option.mainText || option.label || ''
			const subText = option.subText || ''
			const children = [
				h('div', { class: 'terminal-transfer-item__main' }, mainText),
			]
			if (subText) {
				children.push(h('div', { class: 'terminal-transfer-item__sub' }, subText))
			}
			return h('div', { class: 'terminal-transfer-item' }, children)
		},
		async getCplateTerminalList() {
			this.terminalSelectList = []
			const res = await getCplateTerminalListPage({
				departmentId: this.DepartmentId,
				page: 1,
				intPageSize: 1000,
			})
			if (res) {
				if (res.status == 200 && res.data.status == 200) {
					let list = res.data.response.data || []
					list = list.sort((a, b) => {
						let aname = a.AuthDeptName || ''
						let bname = b.AuthDeptName || ''
						return aname.localeCompare(bname, 'zh-CN')
					})
					this.terminalSelectList = list
				} else {
					this.$message.error(res.data.msg || '获取班牌列表失败')
				}
			}
		},
		async onload() {
			this.isLoadingTemplate = true
			const loading = this.$loading({
				lock: true,
				background: 'rgba(0, 0, 0, 0.7)',
			})

			if (this.homeData.Id && (!this.homeData.Grids || !this.homeData.Grids.length)) {
				await this.getHomePage()
			}
			const isPort = this.homeData.IsPortrait === true || this.homeData.IsPortrait === '1' || this.homeData.IsPortrait === 1
			this.isPortrait = isPort
			this.homeData.IsPortrait = isPort

			let re1 = await this.getCustomComponentList()
			loading.close()
			this.$nextTick(() => {
				let layout =
					this.homeData.Grids ||
					(this.isPortrait ? defaultPortraitGrid : defaultGrid)

				let temp = {}
				if (this.homeData.OtherConfig) {
					if (typeof this.homeData.OtherConfig === 'object') {
						temp = this.homeData.OtherConfig
					} else if (typeof this.homeData.OtherConfig === 'string') {
						try {
							temp = JSON.parse(this.homeData.OtherConfig)
						} catch (error) { }
					}
				}

				this.isHomeScreenSaver = temp.isHomeScreenSaver === true ? true : false
				this.isOpenFaceAtten = temp.isOpenFaceAtten === false ? false : true
				this.isShowPhoto = temp.isShowPhoto === false ? false : true
				this.isOpenPersonalSpace =
					temp.isOpenPersonalSpace === false ? false : true
				this.isOpenBottomNav = temp.isOpenBottomNav === false ? false : true
				this.navHeight = Number(temp.navHeight) || 0
				this.KqObject = temp.KqObject || ''
				this.attenMode = temp.attenMode || ''
				this.attenAutoExitTime = temp.attenAutoExitTime || '30'
				this.attenKeepTime = temp.attenKeepTime || '15'
				this.screenSaverTime = temp.screenSaverTime || '5'

				// 恢复分辨率：优先使用 temp 中的设置，其次保留当前已有的自定义分辨率
				if (temp.designWidth !== undefined && temp.designWidth !== null && temp.designWidth !== '') {
					this.designWidth = Number(temp.designWidth)
				} else if (!this.designWidth) {
					this.designWidth = this.isPortrait ? 1080 : 1920
				}
				if (temp.designHeight !== undefined && temp.designHeight !== null && temp.designHeight !== '') {
					this.designHeight = Number(temp.designHeight)
				} else if (!this.designHeight) {
					this.designHeight = this.isPortrait ? 1920 : 1080
				}

				this.pageMode = temp.pageMode || 'DefautModel'
				this.themeMode = temp.themeMode || 'themeDark'
				this.faceSearchThreshold = temp.faceSearchThreshold !== undefined ? temp.faceSearchThreshold : 72
				this.faceLivenessThreshold = temp.faceLivenessThreshold !== undefined ? temp.faceLivenessThreshold : 70
				this.faceLivenessGaThreshold = temp.faceLivenessGaThreshold !== undefined ? temp.faceLivenessGaThreshold : 85
				this.faceRcMode = temp.faceRcMode !== undefined ? temp.faceRcMode : 1
				this.faceSimilarityDelta = temp.faceSimilarityDelta !== undefined ? temp.faceSimilarityDelta : 5
				this.faceLivenessEnabled = temp.faceLivenessEnabled !== false ? true : false
				this.faceAlgorithmType = temp.faceAlgorithmType || 'megvii'

				// 通话配置解析
				this.callMode = temp.callMode || 'normal'
				this.dialMode = temp.dialMode || 'family'
				this.allowedCallTypes = temp.allowedCallTypes || ['voice', 'video']
				this.callVerifyMethod = temp.callVerifyMethod || ['face']
				this.callTimeLimit = temp.callTimeLimit !== undefined ? temp.callTimeLimit : 0
				this.contactsAutoExitSeconds = temp.contactsAutoExitSeconds !== undefined ? temp.contactsAutoExitSeconds : 60
				this.headphonePutDownAction = temp.headphonePutDownAction || 'hangup'
				this.headphonePutUpScreenOn = temp.headphonePutUpScreenOn === true
				this.isHideCallNumber = temp.isHideCallNumber === true
				this.hideCallNumberStart = temp.hideCallNumberStart !== undefined ? temp.hideCallNumberStart : 3
				this.hideCallNumberLen = temp.hideCallNumberLen !== undefined ? temp.hideCallNumberLen : 4
				this.isUpgradeVideoIncoming = temp.isUpgradeVideoIncoming === true
				this.isDisableAllComingCall = temp.isDisableAllComingCall === true
				this.handsetOnlyAnswer = temp.handsetOnlyAnswer === true

				if (temp.mqttConfig) {
					this.mqttConfig = {
						serverUri: temp.mqttConfig.serverUri || 'wss://web.yiqiba.xin/mqtt',
						username: temp.mqttConfig.username || 'admin',
						password: temp.mqttConfig.password || 'public',
						heartbeatInterval: temp.mqttConfig.heartbeatInterval !== undefined ? temp.mqttConfig.heartbeatInterval : 30,
						h5MqttEnabled: temp.mqttConfig.h5MqttEnabled === true ? true : false
					}
				} else {
					this.mqttConfig = {
						serverUri: 'wss://web.yiqiba.xin/mqtt',
						username: 'admin',
						password: 'public',
						heartbeatInterval: 30,
						h5MqttEnabled: false
					}
				}

				this.customConfig = {
					countdown:
						temp.customConfig && temp.customConfig.countdown
							? temp.customConfig.countdown
							: {
								title: '',
								time: '',
								type: 'day',
							},
					personalSpace:
						temp.customConfig && temp.customConfig.personalSpace
							? {
								enableChat: temp.customConfig.personalSpace.enableChat !== false,
								enableOrder: temp.customConfig.personalSpace.enableOrder !== false,
								enableMoral: temp.customConfig.personalSpace.enableMoral !== false,
								customMenus: Array.isArray(temp.customConfig.personalSpace.customMenus)
									? temp.customConfig.personalSpace.customMenus
									: [],
							}
							: {
								enableChat: true,
								enableOrder: true,
								enableMoral: true,
								customMenus: [],
							},
					homeMoralMode:
						temp.customConfig && temp.customConfig.homeMoralMode
							? temp.customConfig.homeMoralMode
							: {
								mode: 'mascot',
							},
				}

				this.dynamicSchema = temp.dynamicSchema || []
				this.dynamicValues = temp.dynamicValues || {}

				layout = layout.map((item) => {
					if (item.mediaUrl) {
						if (item.mediaUrl.indexOf('{') === 0) {
							let temp = JSON.parse(item.mediaUrl)
							item.Times = temp.Times
							item.mediaUrl = temp.mediaUrl
						} else {
							if (item.name == 'custom') {
								item.Times = []
							}
						}
					}
					return item
				})
				this.layout = layout
				this.init()
				this.$nextTick(() => {
					this.isLoadingTemplate = false
				})
			})
		},
		async getHomePage() {
			let res = await getHomePage({
				id: this.homeData.Id,
			})
			if (res) {
				if (res.status == 200 && res.data.status == 200) {
					let data = res.data.response
					if (data) {
						data.TemplateName = this.homeData.TemplateName
						data.IsDefault = this.homeData.IsDefault
						data.BindKqTerminalIds = this.homeData.BindKqTerminalIds || []
						data.AutoTimes = this.homeData.AutoTimes || []
						if (!data.Grids && data.GridsJson) {
							try {
								data.Grids = JSON.parse(data.GridsJson)
							} catch (e) { }
						}
						if (this.homeData.OtherConfig && !data.OtherConfig) {
							data.OtherConfig = this.homeData.OtherConfig
						}
						this.homeData = Object.assign({}, this.homeData, data)
					}
				} else {
					this.$message.error(res.data.msg)
				}
			}
		},
		async getCustomComponentList() {
			let res = await getCustomComponentList({
				departmentId: this.DepartmentId,
			})
			if (res) {
				if (res.status == 200 && res.data.status == 200) {
					let data = res.data.response
					if (data) {
						this.customGrids = data.map((item) => {
							item.name = 'custom'
							return item
						})
					}
				} else {
					this.$message.error(res.data.msg)
				}
			}
		},
		async saveGrid(noPage) {
			if (!this.currentSchoolId) {
				this.$message.warning('请先在顶部选择学校')
				return
			}
			this.DepartmentId = this.currentSchoolId
			if (noPage) {
				const isPort = this.homeData.IsPortrait === true || this.homeData.IsPortrait === '1' || this.homeData.IsPortrait === 1
				this.isPortrait = isPort
				this.homeData.IsPortrait = isPort
			}
			// 清理不在 dynamicSchema 中的 dynamicValues 参数
			if (this.dynamicSchema && Array.isArray(this.dynamicSchema)) {
				const schemaKeys = new Set(this.dynamicSchema.map(item => item.key));
				Object.keys(this.dynamicValues || {}).forEach(key => {
					if (!schemaKeys.has(key)) {
						delete this.dynamicValues[key];
					}
				});
			} else {
				this.dynamicValues = {};
			}

			let grids = JSON.parse(
				JSON.stringify(noPage ? this.homeData.Grids : this.layout)
			)

			if (!noPage) {
				//只有进入了排版界面才需要更新排版内容
				grids = grids.map((item) => {
					if (item.name == 'custom') {
						if (item.Times && item.Times.length) {
							let times = item.Times.filter((ite) => {
								return ite
							})
							if (times.length) {
								item.mediaUrl = JSON.stringify({
									Times: times,
									mediaUrl: item.mediaUrl,
								})
							}
						}
					}
					return item
				})
			}

			let otherConfigStr = this.buildOtherConfig()
			this.homeData.OtherConfig = otherConfigStr
			let page = {
				DepartmentId: this.DepartmentId,
				TemplateName: this.homeData.TemplateName,
				IsDefault: this.homeData.IsDefault === '1' ? true : false,
				BindKqTerminalIds: this.homeData.BindKqTerminalIds,
				AutoTimes: JSON.stringify(this.homeData.AutoTimes),
				IsPortrait: noPage ? this.homeData.IsPortrait : this.isPortrait,
				Grids: grids,
				OtherConfig: otherConfigStr,
			}
			var user = JSON.parse(window.localStorage.user)
			if (user && user.uID > 0) {
				page.CreateBy = user.uRealName

				if (this.homeData.Id) {
					page.Id = this.homeData.Id
					page.CreateBy = this.homeData.CreateBy
					page.CreateTime = this.homeData.CreateTime
					page.ModifyBy = user.uRealName
				}
			} else {
				this.$message({
					message: '用户信息为空，请先登录',
					type: 'error',
				})
				this.$router.replace(
					this.$route.query.redirect ? this.$route.query.redirect : '/'
				)
				return
			}

			let loading = this.$loading({
				text: '正在保存',
				lock: true,
				background: 'rgba(0, 0, 0, 0.7)',
			})
			// 在这里请求服务器以保存页面布局
			let res = await saveHomePage(page)
			loading.close()
			if (res) {
				if (res.status == 200 && res.data.status == 200) {
					if (res.data.response) {
						page.Id = res.data.response
						this.homeData = page

						this.$message({
							message: '模板保存成功',
							type: 'success',
						})

						let list1 = JSON.stringify(this.editDate.BindKqTerminalIds || [])
						let list2 = JSON.stringify(this.homeData.BindKqTerminalIds)
						if (!this.homeData.Id || list1 != list2) {
							loading = this.$loading({
								text: '正在应用终端',
								lock: true,
								background: 'rgba(0, 0, 0, 0.7)',
							})
							let re = await BindKqTerminalHomePage({
								KqTerminalId: this.homeData.BindKqTerminalIds,
								CustomHomePageId: this.homeData.Id || res.data.response,
							})
							loading.close()
							if (re) {
								if (re.status == 200 && re.data.status == 200) {
									this.$message({
										message: '终端应用成功',
										type: 'success',
									})
								} else {
									this.$message.error(re.data.msg || '终端应用失败')
									return
								}
							} else {
								return
							}
						}

						this.isEdit = false
						this.dialogVisible = false
						this.handleQuery()
						return
					}
				}
				this.$message.error(res.data.msg || '保存失败')
			}
		},
		revokePendingVideoLocal() {
			revokeLocalVideoPreview(this.pendingVideoPreviewUrl)
			this.pendingVideoFile = null
			this.pendingVideoPreviewUrl = ''
			this.customVideoPlaySrc = ''
		},
		onAddCustomDialogOpen() {
			this.revokePendingVideoLocal()
			this.customVideoPlaySrc = ''
			this.$nextTick(() => {
				if (this.customForm.mediaType === 'video') {
					this.refreshCustomVideoPlaySrc()
				}
			})
		},
		async refreshCustomVideoPlaySrc() {
			if (this.customForm.mediaType !== 'video' || this.pendingVideoPreviewUrl) {
				this.customVideoPlaySrc = ''
				return
			}
			const raw = this.imageUrl || this.customForm.mediaUrl
			await applyPlayableMediaUrl(this, 'customVideoPlaySrc', raw, this.DepartmentId)
		},
		onAddCustomDialogClose() {
			this.revokePendingVideoLocal()
			this.deferredImageRevoke('cover')
			this.customVideoPlaySrc = ''
			this.addCustom = false
		},
		addCustomGrid() {
			this.$refs.customForm.validate().then(async () => {
				if (this.customForm.mediaType === 'video') {
					const hasVideo = this.pendingVideoFile || (this.imageUrl || this.customForm.mediaUrl || '').trim()
					if (!hasVideo) {
						this.$message.error('请选择视频文件')
						return
					}
				}
				let temp = JSON.parse(JSON.stringify(this.customForm))
				temp.departmentId = this.DepartmentId
				temp.name = 'custom'
				if (temp.icon === '1') {
					temp.icon = temp.mediaUrl
				} else {
					temp.icon = ''
				}
				if (this.deferredImageDisplay('cover', this.coverUrl)) {
					temp.icon = await this.deferredImageEnsure('cover', { foo: 'ModeIndex', currentUrl: this.coverUrl })
				}
				let Times = temp.Times
				// 移除temp内的Times
				delete temp.Times
				if (Times && Times.length) {
					temp.mediaUrl = JSON.stringify({
						Times: Times,
						mediaUrl: temp.mediaUrl,
					})
				}
				if (temp.mediaType === 'video' && this.pendingVideoFile) {
					this.addCustomLoadding = true
					beginVideoUploadProgress(this)
					try {
						const url = await ensureVideoUploaded(
							this.DepartmentId,
							this.pendingVideoFile,
							this.imageUrl || temp.mediaUrl,
							'ModeIndex',
							createVideoUploadProgressHandlers(this)
						)
						this.revokePendingVideoLocal()
						temp.mediaUrl = url
						this.customForm.mediaUrl = url
						this.imageUrl = url
						await this.refreshCustomVideoPlaySrc()
					} catch (e) {
						this.addCustomLoadding = false
						endVideoUploadProgress(this)
						this.$message.error((e && e.message) || '视频上传失败')
						return
					} finally {
						endVideoUploadProgress(this)
					}
				}
				// 在这里向服务器请求保存自定义组件
				this.addCustomLoadding = true

				addCustomComponent(temp)
					.then((res) => {
						this.addCustomLoadding = false
						if (res.status == 200 && res.data.status == 200) {
							if (res.data.response) {
								temp.id = res.data.response
								this.customGrids.push(temp)
								this.$message({
									message: '保存成功',
									type: 'success',
								})
								// 关闭添加自定义组件弹窗
								this.addCustom = false
								return
							}
						}
						this.$message.error(res.data.msg || '保存失败')
					})
					.catch((err) => {
						this.addCustomLoadding = false
						console.log(err)
					})
			})
		},
		removeCustom(index) {
			this.$confirm('确定要删除此自定义组件吗？').then(() => {
				deleteCustomComponent({
					id: this.customGrids[index].id,
				})
					.then((res) => {
						if (res.status == 200 && res.data.status == 200) {
							this.customGrids.splice(index, 1)
							this.$message({
								message: '删除成功',
								type: 'success',
							})
							return
						}
						this.$message.error(res.data.msg || '删除失败')
					})
					.catch((err) => {
						console.log(err)
					})
			})
		},
		handleCoverChange(file) {
			this.deferredImageChange('cover', file, { foo: 'ModeIndex', savedUrl: this.coverUrl })
		},
		beforeAddAvatarUpload(file) {
			if (this.customForm.mediaType == 'image') {
				if (!file.type.startsWith('image/')) {
					this.$message.error('只能上传图片文件！')
					return false
				}
			}
			if (this.customForm.mediaType == 'video') {
				const isMp4 = file.type === 'video/mp4'
				if (!isMp4) {
					this.$message.error('只能上传MP4格式的视频文件！')
					return false
				}
				const isLt100M = file.size / 1024 / 1024 < 100
				if (!isLt100M) {
					this.$message.error('上传视频大小不能超过 100MB!')
					return false
				}
			}
			this.imageLoadding = true
			return true
		},
		handleAddAvatarSuccess(res, file) {
			this.imageLoadding = false
			if (res.success) {
				this.imageUrl = res.response
				this.customForm.mediaUrl = res.response
			} else {
				this.$message.error(res.msg || '上传失败')
			}
		},
		changeMediaType() {
			this.revokePendingVideoLocal()
			this.imageUrl = ''
			this.customForm.mediaUrl = ''
			if (this.customForm.mediaType == 'image') {
				this.customForm.icon = '1'
			} else {
				this.customForm.icon = '0'
			}
		},
		resetGrid() {
			this.selectIndex = -1
			this.layout = JSON.parse(
				JSON.stringify(this.isPortrait ? defaultPortraitGrid : defaultGrid)
			)
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		clearGrid() {
			this.$confirm('确定要清空当前布局的所有组件吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.selectIndex = -1
				this.layout = []
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
				this.$message.success('已清空布局')
			}).catch(() => { })
		},
		deleteGrid() {
			this.$confirm('确定要从页面移除此组件吗？').then(() => {
				let temp = JSON.parse(JSON.stringify(this.layout))
				temp.splice(this.selectIndex, 1)
				this.selectIndex = -1
				this.layout = temp
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			})
		},
		activated(index) {
			this.selectIndex = index
		},
		handleIndexChange(newVal, oldVal) {
			if (this.selectIndex === -1) return

			// 检测序号冲突
			const conflict = this.layout.some((item, idx) => idx !== this.selectIndex && item.i === newVal)
			if (conflict) {
				this.$message.warning(`组件序号 ${newVal} 已被占用，已自动恢复！`)
				this.$nextTick(() => {
					this.$set(this.layout[this.selectIndex], 'i', oldVal)
				})
			}
		},
		deactivated() {
			// this.selectIndex = -1
		},
		getIconSrc(item) {
			if (item.icon === 'default') {
				const localIcon = this[`${item.name}Icon`] || ''
				return this.normalizeLocalAssetUrl(localIcon)
			}
			if (!item.icon) return ''
			return String(item.icon)
		},
		normalizeLocalAssetUrl(url) {
			const p = String(url || '').trim()
			if (!p) return ''
			if (/^https?:\/\//i.test(p) || p.startsWith('blob:') || p.startsWith('data:')) {
				return p
			}
			if (p.startsWith('/')) {
				if (typeof window !== 'undefined' && window.location && window.location.origin) {
					return `${window.location.origin}${p}`
				}
			}
			return p
		},
		dragend(e) {
			let index = 0
			try {
				index = parseInt(e.target.getAttribute('data-index'))
			} catch (error) { }
			let virtual = this.$refs.virtualPageBox.getBoundingClientRect()
			let mouseInGrid = false
			if (
				this.mouseXY.x > virtual.left &&
				this.mouseXY.x < virtual.right &&
				this.mouseXY.y > virtual.top &&
				this.mouseXY.y < virtual.bottom
			) {
				mouseInGrid = true
			}

			if (mouseInGrid === true) {
				let data = JSON.parse(JSON.stringify(this.grids[index]))
				let x = this.backpxX(this.mouseXY.x - virtual.left) - data.width / 2
				let y = this.backpxY(this.mouseXY.y - virtual.top) - data.height / 2
				if (x < 0) {
					x = 0
				}
				if (y < 0) {
					y = 0
				}
				if (x > this.backpxX(virtual.right - virtual.left) - data.width) {
					x = this.backpxX(virtual.right - virtual.left) - data.width
				}
				if (y > this.backpxY(virtual.bottom - virtual.top) - data.height) {
					y = this.backpxY(virtual.bottom - virtual.top) - data.height
				}
				// 四舍五入到整像素
				x = Math.round(x)
				y = Math.round(y)
				this.selectIndex = this.layout.length
				let temp = {
					...data,
					x: x,
					y: y,
					i: this.layout.length ? Math.max(...this.layout.map(item => item.i || 0)) + 1 : 1,
				}
				if (temp.name == 'custom') {
					temp.Times = []
				}
				this.layout.push(temp)
			}
		},
		resizestop(x, y, width, height, i) {
			let temp = JSON.parse(JSON.stringify(this.layout[i]))
			let radio = temp.height / temp.width
			temp.x = Math.round(this.backpxX(x))
			temp.y = Math.round(this.backpxY(y))
			temp.width = Math.round(this.backpxX(width))
			if (temp.lockAspectRatio) {
				temp.height = Math.round(temp.width * radio)
			} else {
				temp.height = Math.round(this.backpxY(height))
			}
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
			this.$set(this.layout, i, temp)
		},
		dragstop(x, y, i) {
			let temp = JSON.parse(JSON.stringify(this.layout[i]))
			temp.x = Math.round(this.backpxX(x))
			temp.y = Math.round(this.backpxY(y))
			this.$set(this.layout, i, temp)
			this.show = false
			this.$nextTick(() => {
				this.show = true
			})
		},
		handleKeyDown(e) {
			if (this.selectIndex === -1 || !this.isEdit) return
			const activeEl = document.activeElement
			if (activeEl) {
				const tagName = activeEl.tagName.toLowerCase()
				if (tagName === 'input' || tagName === 'textarea' || activeEl.hasAttribute('contenteditable')) {
					return
				}
			}

			const key = e.key
			const isShift = e.shiftKey
			const step = isShift ? 10 : 1

			let temp = JSON.parse(JSON.stringify(this.layout[this.selectIndex]))
			let moved = false

			if (key === 'ArrowUp' || key === 'Up') {
				temp.y = Math.max(0, temp.y - step)
				moved = true
				e.preventDefault()
			} else if (key === 'ArrowDown' || key === 'Down') {
				const maxBound = this.designHeight || (this.isPortrait ? 1920 : 1080)
				temp.y = Math.min(maxBound - temp.height, temp.y + step)
				moved = true
				e.preventDefault()
			} else if (key === 'ArrowLeft' || key === 'Left') {
				temp.x = Math.max(0, temp.x - step)
				moved = true
				e.preventDefault()
			} else if (key === 'ArrowRight' || key === 'Right') {
				const maxBound = this.designWidth || (this.isPortrait ? 1080 : 1920)
				temp.x = Math.min(maxBound - temp.width, temp.x + step)
				moved = true
				e.preventDefault()
			}

			if (moved) {
				this.$set(this.layout, this.selectIndex, temp)
				this.show = false
				this.$nextTick(() => {
					this.show = true
				})
			}
		},
		getpagepxX(px) {
			const devW = Number(this.designWidth || (this.isPortrait ? 1080 : 1920));
			const val = (Number(px) * this.pageWidth) / devW;
			return isNaN(val) || val <= 0 ? 10 : Math.round(val);
		},
		getpagepxY(px) {
			const devH = Number(this.designHeight || (this.isPortrait ? 1920 : 1080));
			const val = (Number(px) * this.pageHeight) / devH;
			return isNaN(val) || val <= 0 ? 10 : Math.round(val);
		},
		backpxX(px) {
			const devW = Number(this.designWidth || (this.isPortrait ? 1080 : 1920));
			return (Number(px) * devW) / this.pageWidth;
		},
		backpxY(px) {
			const devH = Number(this.designHeight || (this.isPortrait ? 1920 : 1080));
			return (Number(px) * devH) / this.pageHeight;
		},
		init() {
			this.show = false
			let box = this.$refs.virtualBox
			if (!box) return
			let boxWidth = box.offsetWidth
			let boxHeight = box.offsetHeight

			const devW = Number(this.designWidth) || (this.isPortrait ? 1080 : 1920)
			const devH = Number(this.designHeight) || (this.isPortrait ? 1920 : 1080)
			if (!devW || !devH) return

			const ASPECT_RATIO = devW / devH
			let paddingW = 40
			let paddingH = 120

			let maxWidth = boxWidth - paddingW
			let maxHeight = boxHeight - paddingH

			let scale = 1
			if (maxWidth / maxHeight > ASPECT_RATIO) {
				// 受限于高度
				scale = maxHeight / devH
			} else {
				// 受限于宽度
				scale = maxWidth / devW
			}

			this.pageWidth = devW * scale
			this.pageHeight = devH * scale

			this.$nextTick(() => {
				this.show = true
			})
		},
		// 格式化部门名称：只保留路径 of 最后两级
		formatDepartmentNameCol(row, column, cellValue) {
			if (!cellValue) return '';
			const parts = cellValue.split('/');
			if (parts.length > 2) {
				return parts.slice(-2).join('/');
			}
			return cellValue;
		},
		// 获取个人空间拼接参数展示标签
		getParamLabel(key) {
			const item = this.personalSpaceParamOptions.find(o => o.key === key);
			return item ? `${item.label} (${item.key})` : key;
		},
		// 菜单图标网络/本地路径补齐（参考 DepartmentConfig）
		getMenuIconPath(path) {
			if (!path) return '';
			if (/^(https?:|blob:|data:)/i.test(path)) {
				return path;
			}
			if (path.startsWith('/static/') || path.startsWith('static/')) {
				return 'https://h5.yiqiba.xin' + (path.startsWith('/') ? path : '/' + path);
			}
			if (path.startsWith('/appmenupic/')) {
				return this.$resolveImageSrc ? this.$resolveImageSrc(path) : path;
			}
			let pureFileName = path;
			if (!pureFileName.startsWith('/')) {
				pureFileName = '/' + pureFileName;
			}
			return this.$resolveImageSrc ? this.$resolveImageSrc('/appmenupic' + pureFileName) : ('/appmenupic' + pureFileName);
		},
		// 打开新增自定义菜单弹窗
		openAddCustomMenuDialog() {
			this.isEditCustomMenu = false;
			this.currentCustomMenuIndex = -1;
			this.customMenuForm = {
				id: 'menu_' + Date.now(),
				title: '',
				icon: '',
				type: 'web',
				target: '',
				params: [],
				show: true,
			};
			this.deferredImageRevoke('customMenuIcon');
			this.customMenuDialogVisible = true;
			this.$nextTick(() => {
				this.$refs.customMenuFormRef && this.$refs.customMenuFormRef.clearValidate();
			});
		},
		// 打开编辑自定义菜单弹窗
		openEditCustomMenuDialog(row, index) {
			this.isEditCustomMenu = true;
			this.currentCustomMenuIndex = index;
			this.customMenuForm = {
				id: row.id || ('menu_' + Date.now()),
				title: row.title || '',
				icon: row.icon || '',
				type: 'web',
				target: row.target || '',
				params: Array.isArray(row.params) ? [...row.params] : [],
				show: row.show !== false,
			};
			this.deferredImageInit('customMenuIcon', row.icon);
			this.customMenuDialogVisible = true;
			this.$nextTick(() => {
				this.$refs.customMenuFormRef && this.$refs.customMenuFormRef.clearValidate();
			});
		},
		// 自定义菜单图标选择回调
		handleCustomMenuIconChange(file) {
			this.deferredImageChange('customMenuIcon', file, { foo: 'appmenupic', savedUrl: this.customMenuForm.icon });
		},
		// 保存自定义菜单
		saveCustomMenu() {
			this.$refs.customMenuFormRef.validate(async valid => {
				if (valid) {
					this.savingCustomMenu = true;
					try {
						let iconUrl = await this.deferredImageEnsure('customMenuIcon', {
							foo: 'appmenupic',
							noOss: true,
							currentUrl: this.customMenuForm.icon
						});
						if (!iconUrl && this.customMenuForm.icon) {
							iconUrl = this.customMenuForm.icon;
						}
						const menuData = {
							id: this.customMenuForm.id || ('menu_' + Date.now()),
							title: (this.customMenuForm.title || '').trim(),
							icon: iconUrl ? (this.$resolveImageSrc ? this.$resolveImageSrc(iconUrl) : iconUrl) : '',
							type: 'web',
							target: (this.customMenuForm.target || '').trim(),
							params: Array.isArray(this.customMenuForm.params) ? [...this.customMenuForm.params] : [],
							show: this.customMenuForm.show !== false,
						};
						if (!this.customConfig.personalSpace) {
							this.$set(this.customConfig, 'personalSpace', { enableChat: true, enableOrder: true, enableMoral: true, customMenus: [] });
						}
						if (!Array.isArray(this.customConfig.personalSpace.customMenus)) {
							this.$set(this.customConfig.personalSpace, 'customMenus', []);
						}
						if (this.isEditCustomMenu && this.currentCustomMenuIndex >= 0) {
							this.$set(this.customConfig.personalSpace.customMenus, this.currentCustomMenuIndex, menuData);
						} else {
							this.customConfig.personalSpace.customMenus.push(menuData);
						}
						this.customMenuDialogVisible = false;
						this.$message.success('自定义菜单已' + (this.isEditCustomMenu ? '更新' : '添加') + '，保存当前模板后生效');
					} catch (e) {
						console.error(e);
						this.$message.error('保存自定义菜单失败：' + (e.message || '网络异常'));
					} finally {
						this.savingCustomMenu = false;
					}
				}
			});
		},
		// 删除自定义菜单
		deleteCustomMenu(index) {
			this.$confirm('确定要删除该自定义菜单吗？', '提示', { type: 'warning' }).then(() => {
				if (this.customConfig.personalSpace && Array.isArray(this.customConfig.personalSpace.customMenus)) {
					this.customConfig.personalSpace.customMenus.splice(index, 1);
					this.$message.success('已删除自定义菜单');
				}
			}).catch(() => { });
		},
		// 自定义菜单上移
		moveCustomMenuUp(index) {
			if (index <= 0 || !this.customConfig.personalSpace || !Array.isArray(this.customConfig.personalSpace.customMenus)) return;
			const list = this.customConfig.personalSpace.customMenus;
			const item = list.splice(index, 1)[0];
			list.splice(index - 1, 0, item);
		},
		// 自定义菜单下移
		moveCustomMenuDown(index) {
			if (!this.customConfig.personalSpace || !Array.isArray(this.customConfig.personalSpace.customMenus)) return;
			const list = this.customConfig.personalSpace.customMenus;
			if (index >= list.length - 1) return;
			const item = list.splice(index, 1)[0];
			list.splice(index + 1, 0, item);
		},
	},
}
</script>

<style>
/* 编辑模板 - 应用设备：两行展示班级/名称与设备号 */
.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel {
	width: 280px !important;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__body {
	height: 320px;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__list,
.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__list.is-filterable {
	height: 260px;
	padding: 4px 0;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__item {
	height: auto !important;
	min-height: 44px !important;
	line-height: normal !important;
	display: flex !important;
	align-items: flex-start !important;
	margin: 0 8px 6px !important;
	padding: 8px 10px 8px 8px !important;
	border-radius: 6px;
	border: 1px solid transparent;
	box-sizing: border-box;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__item.el-checkbox {
	display: flex !important;
	align-items: flex-start !important;
	height: auto !important;
	min-height: 44px;
	margin: 0 8px 6px !important;
	padding: 8px 10px 8px 8px !important;
	line-height: normal !important;
	border-radius: 6px;
	border: 1px solid transparent;
	box-sizing: border-box;
	transition: background 0.15s, border-color 0.15s;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__item.el-checkbox:hover {
	background: #f5f7fa;
	border-color: #e4e7ed;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__item .el-checkbox__input {
	position: static !important;
	margin-top: 3px;
	flex-shrink: 0;
}

.terminal-transfer-shell.mode-terminal-transfer .el-transfer-panel__item.el-checkbox .el-checkbox__label {
	position: static !important;
	overflow: visible !important;
	white-space: normal !important;
	text-overflow: clip !important;
	line-height: 1.5 !important;
	height: auto !important;
	flex: 1;
	min-width: 0;
	padding-left: 10px !important;
	display: block !important;
	box-sizing: border-box;
}

.terminal-transfer-shell.mode-terminal-transfer .terminal-transfer-item {
	width: 100%;
}

.terminal-transfer-shell.mode-terminal-transfer .terminal-transfer-item__main {
	font-size: 13px;
	font-weight: 500;
	color: #303133;
	line-height: 1.5;
	word-break: break-word;
}

.terminal-transfer-shell.mode-terminal-transfer .terminal-transfer-item__sub {
	margin-top: 3px;
	font-size: 12px;
	color: #909399;
	line-height: 1.4;
	font-family: Consolas, Monaco, monospace;
	word-break: break-all;
}

.grid-selects .tabs .el-radio-button__inner {
	font-size: 12px !important;
}

.custom-dialog .el-dialog__body {
	padding: 10px 20px 20px 20px !important;
}
</style>

<style scoped>
.mode-index-root {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
	overflow: hidden;
}

.mode-index-page {
	flex: 1 1 auto;
	width: 100%;
	height: 100%;
	min-height: 0;
	overflow: hidden;
}

.mode-index-page .dp-right {
	flex: 1;
	width: 100%;
	min-width: 0;
	min-height: 0;
	overflow: hidden !important;
}

.mode-index-list-shell {
	height: 100%;
	min-height: 0;
}

.mode-index-list-shell>.dp-dept-hint {
	flex-shrink: 0;
	margin: 0 0 10px 0;
	padding: 0 0 8px 0;
	border-bottom: 1px solid #eef2f6;
	font-size: 13px;
	line-height: 1.4;
	color: #475569;
}

.mode-index-table-section {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.mode-index-table-scroll {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	width: 100%;
}

.mode-index-table-scroll .tbl-scroll-host {
	height: 100%;
}

.mode-index-list-pager {
	flex-shrink: 0;
	padding-top: 2px;
}

.mode-index-list-pager ::v-deep .el-pagination {
	margin-top: 4px;
	margin-bottom: 0;
}

.mode-index-root>.container.edit {
	flex: 1 1 auto;
	min-height: 0;
}

.container {
	width: 100%;
	height: 100%;
	display: flex;
}

.bind {
	color: #1e90ff;
	cursor: pointer;
}

.mode-index-page .tbl-scroll-host ::v-deep .el-table .el-button--mini {
	transition: none;
}

.mode-index-page .tbl-scroll-host ::v-deep .el-table .el-button--mini:hover,
.mode-index-page .tbl-scroll-host ::v-deep .el-table .el-button--mini:focus {
	transform: none;
	box-shadow: none;
	background-color: transparent;
}

.virtual {
	box-sizing: border-box;
	background: #70a9d9;
}

.virtualPageBox {
	width: 100%;
	position: relative;
}

.menu {
	display: flex;
	align-items: center;
	justify-content: space-around;
	width: 100%;
	color: white;
	background: #1e90ff;
}

.grid-selects {
	box-sizing: border-box;
	overflow: hidden;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
}

.grid-selects .tabs {
	display: flex;
	justify-content: center;
	width: 100%;
	padding: 10px 5px;
	background: white;
	border-bottom: 1px solid #f0f2f5;
	z-index: 10;
}

.grid-selects .tabs .el-radio-group {
	display: flex;
	width: 100%;
}

.grid-selects .tabs .el-radio-button {
	flex: 1;
}

.grid-selects .tabs .el-radio-button__inner {
	width: 100%;
	padding: 8px 0 !important;
	font-size: 12px !important;
}

.grid-selects .customConfig {
	flex: 1;
	overflow-y: auto;
}

.grid-list {
	flex: 1;
	overflow-y: auto;
	padding: 10px 15px;
}

.grid-select {
	position: relative;
	margin: 0 auto;
	margin-bottom: 10px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
	overflow: hidden;
	cursor: move;
	user-select: none;
}

.grid-select img {
	width: 100%;
	height: 100%;
}

.grid-select .detail {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.grid-select .remove {
	position: absolute;
	top: 0px;
	right: 2px;
	color: red;
	font-size: 24px;
	cursor: pointer;
}

.addBut {
	width: 100% !important;
	max-width: 230px;
	height: 45px !important;
	color: white;
	box-shadow: none;
}

.gridInfo {
	overflow-y: auto;
	position: relative;
	flex: 1;
	border-top: 1px solid #ebeef5;
	box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
	z-index: 9;
	padding: 0 20px 20px 20px;
}

.gridInfo .title {
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0;
	border-bottom: 1px solid #ebeef5;
	margin-bottom: 10px;
}

.gridInfo .title::before {
	content: '';
	display: block;
	width: 3px;
	height: 14px;
	border-radius: 4px;
	margin-right: 5px;
	background: #1e90ff;
}

.gridInfo .el-form-item {
	margin-bottom: 10px;
}

.gridInfo .but {
	width: 100%;
	margin: 10px 0;
}

.grid {
	overflow: hidden;
	position: relative;
	width: 100%;
	height: 100%;
	background: #fff;
	user-select: none;
}

.grid img {
	width: 100%;
	height: 100%;
}

.grid .detail {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
}

.grid .index {
	position: absolute;
	color: #2ed573;
	text-align: center;
	background: #eee;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}

.bind-device-dialog-footer {
	text-align: right;
}

.bind-device-dialog-footer .el-pagination {
	display: inline-block;
}

/* 新的三栏式排版 IDE CSS */
.left-panel {
	width: 280px;
	height: 100%;
	background: #ffffff;
	border-right: 1px solid #e6e8eb;
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);
}

.panel-header {
	height: 50px;
	padding: 0 16px;
	border-bottom: 1px solid #f0f2f5;
	display: flex;
	align-items: center;
	background: #fafafa;
}

.panel-title {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
}

.panel-title i {
	margin-right: 6px;
	color: var(--btn-primary, #2563eb);
}

.preview-panel {
	flex: 1;
	height: 100%;
	background: #f4f5f7;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.preview-header {
	height: 50px;
	padding: 0 20px;
	background: #ffffff;
	border-bottom: 1px solid #e6e8eb;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.template-title-info {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
	display: flex;
	align-items: center;
}

.template-title-info i {
	margin-right: 8px;
	font-size: 16px;
	color: #67c23a;
}

.keyboard-tip {
	font-size: 12px;
	color: #909399;
}

.keyboard-tip i {
	color: #e6a23c;
}

.preview-canvas-wrapper {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: auto;
	padding: 30px;
}

.preview_device {
	background: #1e1e24;
	border: 14px solid #0f0f12;
	border-radius: 20px;
	box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 40px rgba(64, 158, 255, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	position: relative;
	box-sizing: content-box;
}

.device-screen {
	background: #70a9d9;
	overflow: hidden;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
}

.property-panel {
	width: 320px;
	height: 100%;
	background: #ffffff;
	border-left: 1px solid #e6e8eb;
	display: flex;
	flex-direction: column;
	flex-shrink: 0;
	box-shadow: -2px 0 8px rgba(0, 0, 0, 0.03);
}

.property-content {
	flex: 1;
	overflow-y: auto;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
}

.prop-group {
	background: #fafbfe;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 14px;
}

.prop-group-title {
	font-size: 13px;
	font-weight: 600;
	color: #606266;
	margin-bottom: 12px;
	padding-bottom: 6px;
	border-bottom: 1px solid #ebeef5;
}

.prop-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.prop-label {
	font-size: 13px;
	color: #606266;
}

.prop-empty-state {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: #c0c4cc;
	padding: 40px 0;
	text-align: center;
}

.prop-empty-state i {
	font-size: 40px;
	margin-bottom: 10px;
}

.prop-empty-state p {
	font-size: 12px;
	margin: 0;
}

.times-config-box {
	margin-top: 15px;
	border-top: 1px dashed #dcdfe6;
	padding-top: 15px;
}

.times-config-title {
	font-size: 12px;
	font-weight: bold;
	color: #606266;
	margin-bottom: 10px;
}

.times-config-row {
	background: #ffffff;
	border: 1px solid #e4e7ed;
	border-radius: 4px;
	padding: 8px;
	margin-bottom: 10px;
}

.config-tabs {
	border-radius: 6px;
	overflow: hidden;
	box-shadow: none !important;
}

.tab-section-title {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
	padding: 8px 0;
	border-bottom: 1px solid #f0f2f5;
	margin-bottom: 15px;
	display: flex;
	align-items: center;
}

.tab-section-title i {
	margin-right: 6px;
	color: var(--btn-primary, #2563eb);
}

.tab-section-block {
	background: #fafbfc;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 12px 16px 4px;
	margin-bottom: 16px;
}

.tab-section-block .tab-section-title {
	margin-bottom: 12px;
	padding-top: 0;
}

.global-settings-tab .radio-group-wrap {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 8px 20px;
	line-height: 32px;
}

.global-settings-tab .radio-group-wrap .el-radio {
	margin-right: 0 !important;
	line-height: 32px;
	white-space: nowrap;
}

.global-settings-tab .el-form-item {
	margin-bottom: 16px;
}

.time-item-row {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	background: #f8fafc;
	padding: 6px 12px;
	border-radius: 4px;
	border: 1px solid #e2e8f0;
}

.time-label {
	font-size: 12px;
	color: #64748b;
	margin-right: 10px;
	font-weight: 600;
}

.form-unit {
	margin-left: 8px;
	font-size: 13px;
	color: #606266;
}

.form-helper {
	margin-left: 10px;
	font-size: 12px;
	color: #909399;
}

/* 顶部全局操作栏 CSS */
.global-actions-bar {
	display: flex;
	align-items: center;
	gap: 20px;
}

.action-item {
	display: flex;
	align-items: center;
	gap: 8px;
}

.action-label {
	font-size: 13px;
	color: #606266;
	font-weight: 500;
}

.action-buttons {
	display: flex;
	gap: 8px;
	border-left: 1px solid #ebeef5;
	padding-left: 20px;
}

.keyboard-tip-group {
	background: #fdf6ec !important;
	border: 1px solid #faecd8 !important;
}

.keyboard-tip-content {
	font-size: 12px;
	color: #e6a23c;
	line-height: 1.6;
}

.keyboard-tip-content i {
	font-size: 14px;
	margin-right: 4px;
}

.bottom-content-area {
	flex: 1;
	display: flex;
	overflow: hidden;
}

/* 自定义菜单配置样式 */
.custom-menu-table-icon {
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background: #f1f5f9;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 auto;
}

.custom-menu-icon-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	background: #fafafa;
	transition: border-color 0.2s;
}

.custom-menu-icon-uploader .el-upload:hover {
	border-color: #409EFF;
}

.custom-menu-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 78px;
	height: 78px;
	line-height: 78px;
	text-align: center;
}

.custom-menu-avatar {
	width: 78px;
	height: 78px;
	display: block;
}

.custom-menu-url-preview-card {
	margin-top: 15px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	border-radius: 6px;
	padding: 12px 16px;
}

.custom-menu-url-preview-card .preview-header {
	font-size: 13px;
	font-weight: bold;
	color: #334155;
	margin-bottom: 6px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.custom-menu-url-preview-card .preview-content {
	font-family: Consolas, Monaco, monospace;
	font-size: 12px;
	color: #2563eb;
	word-break: break-all;
	background: #ffffff;
	padding: 8px 12px;
	border-radius: 4px;
	border: 1px solid #cbd5e1;
	min-height: 36px;
	display: flex;
	align-items: center;
}

.custom-menu-url-preview-card .preview-hint {
	font-size: 11px;
	color: #94a3b8;
	margin-top: 5px;
}

/* 自定义菜单删除操作按钮红色高亮样式 */
.custom-menu-del-btn,
.custom-menu-del-btn.el-button--text {
	color: #F56C6C !important;
}

.custom-menu-del-btn:hover,
.custom-menu-del-btn.el-button--text:hover,
.custom-menu-del-btn:focus,
.custom-menu-del-btn.el-button--text:focus {
	color: #ff4949 !important;
}
</style>
